import { Spin, Table, TableProps } from 'antd'
import styled from 'styled-components'
import WizrText from './WizrText'
import WizrTag from './WizrTags'
import WizrButton from './WizrButton'
import FolderIcon from '../assets/icons/Folder'
import FileIcon from '../assets/icons/FileIcon'
import WizrAvatar from './WizrAvatar'
import { dispatchUpdateCurrentFolder, dispatchTicketDetails, dispatchupdateUserView, dispatchCurrentModule, dispatchDeleteTicketsFaqPt, dispatchListUserRows, dispatchCustomerHealthDetails, dispatchSingleConversationData, dispatchAddNewReports, dispatchGetReportsForControlRoom, dispatchGetAlertDetails, dispatchUpdateAlert, dispatchGetAlertsForControlRoom } from '../redux/actions/content'
import { useWizrModalContext, MODAL_TYPES } from '../providers/modal/WizrModalProvider'
import { cronToHumanReadable, routerHistory } from '../utils'
import FolderActionPopOver from './popovers/FolderAction'
import FileActionPopOver from './popovers/FileAction'
import PromptActionPopOver from './popovers/PromptAction'
import AppActionPopOver from './popovers/AppAction'
import ReportActionPopOver from './popovers/ReportActionPopOver'
import AlertActionPopOver from './popovers/AlertActionPopOver'
// import PdflogoIcon from '../assets/icons/Pdflogo'
import DoclogoIcon from '../assets/icons/Doclogo'
import UrlIcon from '../assets/icons/UrlIcon'
import { LoadingOutlined } from '@ant-design/icons'
import AppRun from './popovers/AppRun'
import FileName from './popovers/FileName'
import BulkRunDownload from './popovers/BulkRunDownload'
import TenantActionPopOver from './popovers/TenantActionPopOver'
import UserAction from './popovers/UserAction'
import ProductActionPopOver from './popovers/ProductAction'
import RolesActionPopover from './popovers/RolesActionPopover'
import WizrFlexLayout from './WizrFlexLayout'
import PackageActionPopOver from './popovers/packageAction'
import IntegrationActionPopOver from './popovers/IntegrationActionPopOver'
import GroupActionPopover from './popovers/GroupActionPopover'
import LlmDbRowActionPopover from './popovers/LlmDbRowActionPopover'
import InfoIcon from '../assets/icons/Info'
import TicketActionPopover from './popovers/TicketActionPopover'
import PersonaActionPopOver from './popovers/PersonaActionPopOver'
import ZendeskIcon from '../assets/icons/ZendeskIcon'
import DeleteIcon from '../assets/icons/DeleteIcon'
import CustomerHealthCustomerCard from './popovers/CustomerHealth'
import CustomerHealthRoundTag from './popovers/CustomerHealthRoundTag'
import WizrIcon from './WizrIcon'
import Freshdesk from '../assets/icons/FreshdeskIcon'
import { useAuth } from '../authContext'
import Salesforce from '../assets/icons/Salesforce'
import ConfluenceIcon from '../assets/icons/confluence'
import SchedulerActionPopover from './popovers/SchedulerAction'
import JiraIcon from '../assets/icons/Jira'
import SlackIcon from '../assets/icons/SlackIcon'
import ServiceNowIcon from '../assets/icons/ServiceNowIcon'
import GoogleDriveIcon from '../assets/icons/GoogleDrive'
import OneDriveIcon from '../assets/icons/oneDrive'
import SharepointIcon from '../assets/icons/sharepoint'
import PostgreSQLIcon from '../assets/icons/PostgreSQLIcon'
import SMTPIcon from '../assets/icons/SMTPIcon'
import TicketCountDisplay from './TicketCountDisplay'
import { Resizable } from 'react-resizable'
import 'react-resizable/css/styles.css'
import React, { useState, useCallback, useMemo } from 'react'
import CustomStatusFilter from './filters/CustomStatusFilter'
import FilterIconWithBadge from './filters/FilterIconWithBadge'
import { customerInteractionAgentAssistHistory } from '../api/helpers/contents'
import WizrToggleButton from './WizrToggleButton'
import Gemini from '../icons/Gemini'
import Pinecone from '../assets/icons/Pinecone'
import EndUser from '../assets/icons/EndUser'
import SendEmailIcon from '../assets/icons/SendEmailIcon'
import MongoDBIcon from '../assets/icons/MongoDbIcon'
import PgVectorIcon from '../assets/icons/PgVectorIcon'
import MilvusIcon from '../assets/icons/MilvusIcon'
import QdrantIcon from '../assets/icons/QdrantIcon'
import WeaviateIcon from '../assets/icons/WeaviateIcon'
// import PdfIcon from '../assets/icons/PdfIcon'

// Utility function to format UTC dates to browser's local timezone
const formatDateToLocal = (dateString: string): string => {
  if (!dateString) return '';

  try {
    let date: Date;

    // Handle ISO format timestamps (e.g., "2025-08-27T11:03:51.206881")
    if (dateString.includes('T') && dateString.includes('.')) {
      date = new Date(dateString + 'Z'); // Treat as UTC
    } else {
      date = new Date(dateString);
    }

    if (isNaN(date.getTime())) {
      return dateString; // fallback if invalid date
    }

    const now = new Date();
    const sameYear = date.getFullYear() === now.getFullYear();

    // Use Intl for timezone-safe conversion
    const options: Intl.DateTimeFormatOptions = {
      month: 'short',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };

    if (!sameYear) {
      options.year = 'numeric';
    }

    return date.toLocaleString('en-US', options);
  } catch (error) {
    console.error('Error formatting date:', error);
    return dateString;
  }
};


type WizrTableType =
  | 'folder'
  | 'file'
  | 'prompt'
  | 'history'
  | 'App'
  | 'AppTemplate'
  | 'AppDraft'
  | 'apphistory'
  | 'autosolvetesthistory'
  | 'autosolveevalshistory'
  | 'bulkrun'
  | 'tenants'
  | 'users'
  | 'billing'
  | 'invoice'
  | 'products'
  | 'roles'
  | 'packages'
  | 'past_tickets'
  | 'integrations'
  | 'grouplisting'
  | 'intentcategorytable'
  | 'tagkeywordtable'
  | 'tickettable'
  | 'sentimenttable'
  | 'tickettypetable'
  | 'customfieldtable'
  | 'persona'
  | 'tickets'
  | 'integrationsSettings'
  | 'AppDraftMaster'
  | 'AppMaster'
  | 'faq'
  | 'customerHealth'
  | 'appInsights'
  | 'appInsightsSingle'
  | 'scheduler'
  | 'schedulerHistory'
  | 'agentperfomancetag'
  | 'agentInsights'
  | 'customerInteractions'
  | 'customerInteractionsAgentAssist'
  | 'alerts'
  | 'reports'
  | 'trustforteList'
  | 'ai_db'

interface TableColumn {
  title: React.ReactNode;
  dataIndex: string;
  key: string;
  render: (text: string) => React.ReactNode;
}

interface IWizrTable extends TableProps<any> {
  type: WizrTableType
  tabSelected?: string
  rowSelection?: any
  handleRowClick?: any
  handleRowAgentAssistClick?: any
  payload?: any
  customColumns?: TableColumn[]; // Add this new prop
  resizable?: boolean; // Enable/disable column resizing (default: true)
  dataSource?: any[]; // Add dataSource prop
  columns?: any[]; // Add columns prop
  pagination?: any; // Add pagination prop
  size?: 'small' | 'middle' | 'large'; // Use proper SizeType
  scroll?: any; // Add scroll prop
}

// Define a mapping of file_source to icons
const fileSourceIcons: { [key: string]: React.ReactNode } = {
  'Doc Ai': <DoclogoIcon />,
  'My Computer': <FileIcon />,
  'googledrive': <GoogleDriveIcon />,
  Slack: <SlackIcon />,
  Confluence: <ConfluenceIcon />,
  'Web Page': <UrlIcon />,
  Sharepoint: <SharepointIcon />,
  'onedrive': <OneDriveIcon />,
  // Add more mappings as needed
};

// Helper function to format source name for display
const formatSourceName = (source: string): string => {
  const sourceNameMap: { [key: string]: string } = {
    'googledrive': 'Google Drive',
    'slack': 'Slack',
    'confluence': 'Confluence',
    'web page': 'Web Page',
    'sharepoint': 'Sharepoint',
    'doc ai': 'Doc Ai',
    'my computer': 'My Computer',
    'onedrive': 'One Drive',
  };

  return sourceNameMap[source?.toLowerCase()] || source;
};

// First, add the pattern at the top of the file
const patternUserStatus = /extension_[a-f0-9]{32}_UserStatus/;

// Resizable Header Cell Component
interface ResizableHeaderCellProps {
  children?: React.ReactNode;
  width?: number | string;
  onResize?: (e: React.SyntheticEvent, { size }: { size: { width: number; height: number } }) => void;
  className?: string;
  style?: React.CSSProperties;
  onClick?: React.MouseEventHandler<any>;
  onMouseEnter?: React.MouseEventHandler<any>;
  onMouseLeave?: React.MouseEventHandler<any>;
}

const ResizableHeaderCell: React.FC<ResizableHeaderCellProps> = ({
  children,
  width,
  onResize,
  className,
  style,
  ...restProps
}) => {
  const [isResizing, setIsResizing] = useState(false);

  if (!width) {
    return <th className={className} style={style} {...restProps}>{children}</th>;
  }

  return (
    <Resizable
      width={typeof width === 'string' ? parseInt(width) : width}
      height={0}
      handle={
        <button
          type="button"
          className="react-resizable-handle"
          onClick={e => e.stopPropagation()}
          onMouseDown={e => e.stopPropagation()}
          onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              e.stopPropagation();
            }
          }}
          aria-label="Resize column"
        />
      }
      onResize={onResize}
      onResizeStart={(e: any) => {
        setIsResizing(true);
      }}
      onResizeStop={(e: any) => {
        setIsResizing(false);
      }}
      draggableOpts={{ enableUserSelectHack: false }}
    >
      <th
        className={className}
        style={{ ...style, width, cursor: isResizing ? 'col-resize' : 'default' }}
        {...restProps}

      >
        {children}
      </th>
    </Resizable>
  );
};

const ScrollableTagsContainer = styled.div`
  max-height: 100px;
  overflow: auto;
  max-width: 600px;
  scrollbar-width: thin;
  scrollbar-color: #888 #f1f1f1;

  &::-webkit-scrollbar {
    width: 3px;
    height: 3px;
  }

  &::-webkit-scrollbar-button {
    display: none;
    width: 0;
    height: 0;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 2px;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 2px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  &::-webkit-scrollbar-corner {
    background: transparent;
  }
`;

const WizrTable = ({
  type,
  tabSelected,
  rowSelection,
  customColumns, // Add this to props
  handleRowClick,
  handleRowAgentAssistClick,
  payload,
  resizable = true, // Default to true
  ...props
}: IWizrTable): JSX.Element => {

  const { hasAcces } = useAuth();
  const { showModal, hideModal } = useWizrModalContext();


  // State for managing resizable columns
  const [columnWidths, setColumnWidths] = useState<{ [key: string]: number }>({});

  // State for tracking active filter counts
  const [activeFilterCounts, setActiveFilterCounts] = useState<{ [key: string]: number }>({});

  const uniqueAppNames = new Set();
  const uniqueAppId = new Set();

  props?.dataSource && props?.dataSource.forEach(item => {
    uniqueAppNames.add(item.app_name);
  });

  props?.dataSource && props?.dataSource.forEach(item => {
    uniqueAppId.add(item.app_id);
  });

  // Convert the Set to an array and map it to the desired structure
  const filerArrayAppname = Array.from(uniqueAppNames).map((appName, index) => ({
    text: appName, // Assign a new unique id starting from 1
    value: appName
  }));

  const filerArrayAppId = Array.from(uniqueAppId).map((appId, index) => ({
    text: appId, // Assign a new unique id starting from 1
    value: appId
  }));

  // Custom filter functions for the new design
  const getStatusFilterIcon = (filtered: boolean) => {
    const filterCount = activeFilterCounts['accountEnabled'] || 0;
    return <FilterIconWithBadge filtered={filtered} filterCount={filterCount} />;
  };

  const getStatusFilterDropdown = ({ setSelectedKeys, selectedKeys, confirm, clearFilters, visible }: any) => (
    <CustomStatusFilter
      selectedKeys={selectedKeys}
      setSelectedKeys={setSelectedKeys}
      confirm={confirm}
      clearFilters={clearFilters}
      visible={visible}
      onFilterCountChange={(count: number) => {
        setActiveFilterCounts(prev => ({
          ...prev,
          'accountEnabled': count
        }));
      }}
    />
  );

  const getStatusFilter = (value: any, record: any) => {
    // Find the user status key using the pattern
    const userStatusKey = Object.keys(record).find(key => patternUserStatus.test(key));
    const userStatus = userStatusKey ? record[userStatusKey] : null;

    if (value === 'active') return record.accountEnabled === true && record.signInActivity?.lastSignInDateTime;
    if (value === 'inactive') return record.accountEnabled === false;
    if (value === 'created') return record.accountEnabled === true && userStatus === 'User created';
    if (value === 'inviteSend') {
      return (
        record.accountEnabled === true &&
        userStatus === 'Invitation sent' &&
        (!record.signInActivity?.lastSignInDateTime)
      );
    }
    return false;
  };

  const getStatusRender = (_: any, record: any) => {
    let label = '';
    let color = '';

    // Find the user status key using the pattern
    const userStatusKey = Object.keys(record).find(key => patternUserStatus.test(key));
    const userStatus = userStatusKey ? record[userStatusKey] : null;

    // Check for INVITE SEND first
    if (
      record.accountEnabled === true &&
      userStatus === 'Invitation sent' &&
      (!record.signInActivity?.lastSignInDateTime)
    ) {
      label = 'INVITE SEND';
      color = '#C4C7CC';
    }
    // Then check for CREATED
    else if (record.accountEnabled === true && userStatus === 'User created') {
      label = 'CREATED';
      color = '#C4C7CC';
    }
    // Then check for ACTIVE
    else if (record.accountEnabled === true && record.signInActivity?.lastSignInDateTime) {
      label = 'ACTIVE';
      color = '#22C55E';
    }
    // Otherwise, INACTIVE
    else if (record.accountEnabled === false) {
      label = 'INACTIVE';
      color = '#EF4444';
    }

    return (
      <WizrTag
        background={color}
        data={[label]}
        borderradius='4px'
      />
    );
  };

  const filterValues: any = [
    // {
    //   text: 'App1',
    //   value: 'App1',
    // },
    // {
    //   text: 'App2',
    //   value: 'App2',
    // },
    // {
    //   text: 'App3',
    //   value: 'App3',
    // },
  ]

  const tableColumnConfigs: { [key: string]: any } = {
    folder: [
      {
        title: 'Name',
        dataIndex: 'folder_name',
        key: 'folder_name',
        sorter: (a: any, b: any) => a.folder_name.localeCompare(b.folder_name),
        render: (text: string, folderDetail: any) => (
          <WizrButton
            padding={'0px'}
            icon={<FolderIcon />}
            text={text}
            type='text'
            onClick={() => {
              dispatchUpdateCurrentFolder(folderDetail)
              routerHistory.navigate(`folder/${folderDetail?.folder_id}`)
            }}
          />
        ),
      },
      {
        title: 'Owner',
        dataIndex: 'owner',
        key: 'owner',
        sorter: (a: any, b: any) => a.user_name.localeCompare(b.user_name),
        render: (text: string, folderDetail: any) => (
          <WizrAvatar name={folderDetail?.user_name} background='transparent'></WizrAvatar>
        ),
      },
      {
        title: 'Description',
        dataIndex: 'folder_description',
        key: 'folder_description',
        render: (text: string) => (
          <div style={{ maxHeight: '200px', overflow: 'auto', maxWidth: '600px' }}>
            <WizrText type='body2'>{text}</WizrText>
          </div>
        ),
      },
      {
        title: 'Vector DB',
        dataIndex: 'vector_config_display_name',
        key: 'vector_config_display_name',
        render: (text: string) => (
          <WizrText type='body2'>{text || '-'}</WizrText>
        ),
      },
      {
        title: '',
        dataIndex: 'moreAction',
        render: (text: string, folderDetail: any) => hasAcces('update_folder') || hasAcces('delete_folder') ? <FolderActionPopOver detail={folderDetail} type={'knowledge_base'} /> : <></>,
      },
    ],
    past_tickets: [
      {
        title: 'Name',
        dataIndex: 'folder_name',
        key: 'folder_name',
        render: (text: string, folderDetail: any) => (
          <WizrButton
            padding={'0px'}
            icon={<FolderIcon />}
            text={text}
            type='text'
          />
        ),
      },
      {
        title: 'Description',
        dataIndex: 'folder_description',
        key: 'folder_description',
        render: (text: string) => (
          <div style={{ maxHeight: '200px', overflow: 'auto', minWidth: '600px' }}>
            <WizrText type='body2'>{text}</WizrText>
          </div>
        ),
      },
      {
        title: 'Vector DB',
        dataIndex: 'vector_config_display_name',
        key: 'vector_config_display_name',
        render: (text: string) => (
          <WizrText type='body2'>{text || '-'}</WizrText>
        ),
      },
      {
        title: 'Created On',
        dataIndex: 'created_on',
        key: 'created_on',
        render: (text: number) => (
          <WizrText type='body2'>
            {new Date(text).toLocaleString('en-GB', {
              year: '2-digit',
              month: '2-digit',
              day: '2-digit',
              hour: 'numeric',
              minute: 'numeric',
              hour12: true,
            })}
          </WizrText>
        ),
      },
      {
        title: '',
        dataIndex: 'moreAction',
        render: (text: string, folderDetail: any) => hasAcces('update_ptfolder') || hasAcces('delete_ptfolder') ? <FolderActionPopOver detail={folderDetail} type={'past_tickets'} /> : <></>,
      },
    ],
    faq: [
      {
        title: '',
        dataIndex: 'folder_name',
        key: 'folder_name',
        render: (text: string, folderDetail: any) => (
          <WizrButton
            padding={'0px'}
            icon={<FolderIcon />}
            text={text}
            type='text'
            onClick={() => {
              // dispatchUpdateCurrentFolder(folderDetail)
              routerHistory.navigate(`faq/${folderDetail?.folder_id}`)
            }}
          />
        ),
      },
      {
        title: '',
        dataIndex: 'folder_description',
        key: 'folder_description',
        render: (text: string) => (
          <div style={{ maxHeight: '200px', overflow: 'auto', minWidth: '600px' }}>
            <WizrText type='body2'>{text}</WizrText>
          </div>
        ),
      },
      {
        title: '',
        dataIndex: 'created_on',
        key: 'created_on',
        render: (text: number) => (
          <WizrText type='body2'>
            {new Date(text).toLocaleString('en-GB', {
              year: '2-digit',
              month: '2-digit',
              day: '2-digit',
              hour: 'numeric',
              minute: 'numeric',
              hour12: true,
            })}
          </WizrText>
        ),
      },
      {
        title: '',
        dataIndex: 'moreAction',
        render: (text: string, folderDetail: any) => hasAcces('delete_faqfolder') || hasAcces('update_faqfolder') ? <FolderActionPopOver detail={folderDetail} type={'faq'} /> : <></>,
      },
    ],
    tickets: [
      {
        title: 'Ticket id',
        dataIndex: 'ticket_id',
        sorter: (a: any, b: any) => a.ticket_id.localeCompare(b.ticket_id),
        render: (text: string) => (
          <div>
            <WizrText type='body2'>{text}</WizrText>
          </div>
        ),
        key: 'ticket_id',
      },
      {
        title: 'Subject',
        dataIndex: 'subject',
        sorter: (a: any, b: any) => a.user_name.localeCompare(b.user_name),
        key: 'subject',
        render: (text: string) => (
          <div>
            <WizrText type='body2'>{text}</WizrText>
          </div>
        ),
      },
      {
        title: 'Category',
        dataIndex: 'category',
        key: 'category',
        render: (text: string) => (
          <div>
            <WizrText type='body2'>{text}</WizrText>
          </div>
        ),
      },

      {
        title: 'Ticket Priority',
        dataIndex: 'priority',
        key: 'priority',
        render: (text: string) => {

          let backgroundColor;

          switch (text.toLowerCase()) {
            case 'high':
              backgroundColor = '#EF4444';
              break;
            case 'medium':
              backgroundColor = '#FBBF24';
              break;
            case 'low':
              backgroundColor = '#9475DE';
              break;
            default:
              backgroundColor = '#991B1B';
          }

          return (
            <WizrTag
              background={backgroundColor}
              data={[text]}
              borderradius="4px"
            />
          );
        },
      },

      {
        title: 'Raised by',
        dataIndex: 'raised_by',
        key: 'raised_by',
        render: (text: string, fileDetail: any) => (
          <WizrAvatar background='transparent' name={text}></WizrAvatar>
        ),
      },
      {
        title: 'Created On',
        dataIndex: 'ticket_created_on',
        key: 'ticket_created_on',
        render: (text: string) => (
          <div>
            <WizrText type='body2'>{text}</WizrText>
          </div>
        ),
      },
      {
        title: '',
        dataIndex: '',
        render: (text: string, record: any) =>
          <div>
            <WizrButton
              icon={<InfoIcon />}
              type='text'
              onClick={() => {
                showModal(MODAL_TYPES.TICKET_DETAILS, {
                  rowDetails: record,
                  onCancel: hideModal,
                });
              }}
            />
          </div>,
      },
      {
        title: '',
        dataIndex: '',
        key: '',
        render: (text: any, record: any) => {
          return record?.type === 'faq' ? (
            <div>
              <WizrButton
                icon={<DeleteIcon />}
                type='text'
                onClick={async () => {
                  await dispatchDeleteTicketsFaqPt(record?.row_id, record?.type);
                  await dispatchListUserRows(record?.type, record?.folderId);
                }}
                disabled={!hasAcces('delete_faqfile') || !hasAcces('delete_ptfile')}
              />
            </div>
          ) : <div></div>;
        }
      },
    ],
    file: [
      {
        title: 'Name',
        dataIndex: 'file_name',
        sorter: (a: any, b: any) => a.file_name.localeCompare(b.file_name),
        render: (text: string, details: any) => {
          return (
            <div style={{ maxWidth: '800px', overflow: 'auto' }}>
              <FileName details={details} text={text} />
            </div>
          )
        },
        key: 'file_name',
      },
      {
        title: 'Owner',
        dataIndex: 'owner',
        sorter: (a: any, b: any) => a.user_name.localeCompare(b.user_name),
        key: 'owner',
        render: (text: string, fileDetail: any) => (
          <WizrAvatar background='transparent' name={fileDetail?.user_name}></WizrAvatar>
        ),
      },
      {
        title: 'Tags',
        dataIndex: 'tags',
        render: (text: any) => {
          return text?.length > 0 && text[0] !== '' ? <WizrTag type='colorfull' data={text} /> : null
        },
      },
      {
        title: 'Source',
        dataIndex: 'file_source',
        key: 'file_source',
        sorter: (a: any, b: any) => a.file_source.localeCompare(b.file_source),
        render: (text: string) => {
          const formattedName = formatSourceName(text);
          return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
              {fileSourceIcons[text] || fileSourceIcons[formattedName]} {/* Use the icon or a default one */}
              <WizrText type='body2' style={{ marginLeft: 8 }}>{formattedName}</WizrText>
            </div>
          );
        },
      },

      {
        title: 'Upload Status',
        dataIndex: 'upload_status',
        key: 'upload_status',
        render: (text: string) => (
          <WizrText type='body2'>
            {text}
            {text === 'inprogress' ? (
              <Spin indicator={<LoadingOutlined style={{ fontSize: 15, marginLeft: 5 }} spin />} />
            ) : (
              <></>
            )}
          </WizrText>
        ),
      },


      {
        title: '',
        dataIndex: '',
        render: (text: string, fileDetail: any) => <FileActionPopOver detail={fileDetail} />,
      },
    ],
    prompt: [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>,
        sorter: (a: any, b: any) => a.name.localeCompare(b.name),
      },
      {
        title: 'Owner',
        dataIndex: 'user_name',
        key: 'user_name',
        render: (text: string, promptDetail: any) => (
          <WizrAvatar gapSize={-10} name={promptDetail?.user_name} background='#FFF'></WizrAvatar>
        ),
        sorter: (a: any, b: any) => a.user_name.localeCompare(b.user_name),
      },
      {
        title: 'Description',
        dataIndex: 'description',
        key: 'description',
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>,
      },
      {
        title: 'Tags',
        dataIndex: 'tags',
        key: 'tags',
        render: (tags: string[], record: any) => (
          <WizrTag type='colorfull' checkable={false} data={tags} />
        ),
        sorter: (a: any, b: any) => (a.tags?.length || 0) - (b.tags?.length || 0),
      },
      {
        title: 'Last UpdatedOn',
        dataIndex: 'updated_on',
        key: 'updated_on',
        render: (text: number) => (
          <WizrText type='body2'>
            {new Date(text).toLocaleString('en-GB', {
              year: '2-digit',
              month: '2-digit',
              day: '2-digit',
              hour: 'numeric',
              minute: 'numeric',
              hour12: true,
            })}
          </WizrText>
        ),
        sorter: (a: any, b: any) => a?.updated_on - b?.updated_on,
      },
      {
        title: '',
        dataIndex: '',
        render: (text: any, promptDetail: any) => (
          <PromptActionPopOver detail={promptDetail} tabSelected={text.published} />
        ),
      },
    ],
    history: [
      {
        title: 'Model',
        width: 100,
        dataIndex: 'llm_model_name',
        key: 'llm_model_name',
        render: (text: string) => (
          <div style={{ maxHeight: '200px', overflow: 'auto' }}>
            <WizrText type='body4'>{text}</WizrText>
          </div>
        ),
      },
      {
        title: 'Query',
        width: 190,
        dataIndex: 'query',
        key: 'query',
        render: (text: string) => (
          <div style={{ maxHeight: '200px', overflow: 'auto' }}>
            <WizrText type='body4'>{text}</WizrText>
          </div>
        ),
      },
      {
        title: 'Output',
        width: 400,
        dataIndex: 'response',
        key: 'response',
        render: (text: string) => (
          <div
            style={{
              maxHeight: '200px',
              overflow: 'auto',
              whiteSpace: 'pre-wrap',
              overflowWrap: 'break-word',
            }}
          >
            <WizrText type='body4'>{text}</WizrText>
          </div>
        ),
      },
      {
        title: 'System',
        width: 300,
        dataIndex: 'system_message_test_values',
        key: 'system_message_test_values',
        render: (text: string) => (
          <div style={{ maxHeight: '200px', overflow: 'auto' }}>
            <WizrText type='body4'>{text}</WizrText>
          </div>
        ),
      },
      {
        title: 'Feedback',
        width: 70,
        dataIndex: 'feedback',
        key: 'feedback',
        render: (text: number) => {
          let feedbackLabel;
          if (text === 0) {
            feedbackLabel = 'LIKE';
          } else if (text === 1) {
            feedbackLabel = 'DISLIKE';
          } else {
            feedbackLabel = 'NA';
          }
          return (
            <div style={{ maxHeight: '200px', overflow: 'auto' }}>
              <WizrText type='body4'>{feedbackLabel}</WizrText>
            </div>
          );
        },
      },
      {
        title: 'Comments',
        width: 70,
        dataIndex: 'comment',
        key: 'comment',
        render: (text: string) => (
          <div style={{ maxHeight: '200px', overflow: 'auto' }}>
            <WizrText type='body4'>{text || 'NA'}</WizrText>
          </div>
        ),
      },
      {
        title: 'Parameters',
        width: 100,
        dataIndex: 'message_params_test_values',
        key: 'message_params_test_values',
        render: (text: any) => (
          <div style={{ maxHeight: '200px', overflow: 'auto' }}>
            {' '}
            <WizrText type='body4'>
              {!text || Object.keys(text).length === 0 ? 'NA' : JSON.stringify(text)}
            </WizrText>
          </div>
        ),
      },
      {
        title: 'Temperature',
        width: 70,
        dataIndex: ['prompt_body', 'temperature'],
        key: 'temperature',
        render: (text: string) => (
          <div style={{ maxHeight: '200px', overflow: 'auto' }}>
            {' '}
            <WizrText type='body4'>{text}</WizrText>
          </div>
        ),
      },
      {
        title: 'Token Limit',
        width: 70,
        dataIndex: ['prompt_body', 'max_tokens'],
        key: 'max_tokens',
        render: (text: string) => (
          <div style={{ maxHeight: '200px', overflow: 'auto' }}>
            <WizrText type='body4'>{text}</WizrText>
          </div>
        ),
      },

      {
        title: 'Zero Shot',
        width: 80,
        dataIndex: ['prompt_body', 'zero_shot'],
        key: 'zero_shot',
        render: (text: boolean) => (
          <div style={{ maxHeight: '200px', overflow: 'auto' }}>
            {' '}
            <WizrText type='body4'>{text === true ? 'true' : 'false'}</WizrText>
          </div>
        ),
      },
      {
        title: 'Example',
        width: 250,
        dataIndex: 'examples_test_values',
        key: 'examples_test_values',
        render: (text: any = '') => {
          const hasText = text?.length;
          return hasText ? (
            <div style={{ maxHeight: '200px', overflow: 'auto' }}>
              <WizrText type='body4'>
                {text.map((item: any) => {
                  return `{"user": "${item.user}", "assistant": "${item.assistant}"}`
                })}
              </WizrText>
            </div>
          ) : (
            <WizrText type='body4'>NA</WizrText>
          );
        },
      },
      {
        title: 'Token Used',
        width: 70,
        dataIndex: ['llm_audit', 'total_tokens'],
        key: 'total_tokens',
        render: (text: string) => <WizrText type='body4'>{text}</WizrText>,
      },
      {
        title: 'Username',
        width: 70,
        dataIndex: 'user_name',
        key: 'user_name',
        render: (text: string) => <WizrText type='body4'>{text}</WizrText>,
      },
      {
        title: 'Time of Run',
        dataIndex: 'run_time',
        key: 'run_time',
        render: (text: number) => (
          <WizrText type='body2'>
            {new Date(text).toLocaleString('en-US', {
              month: 'short',
              day: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
              second: 'numeric',
              hour12: true,
            })}
          </WizrText>
        ),
      },
      {
        title: 'Time of Response',
        dataIndex: ['llm_audit', 'response_time'],
        key: 'response_time',
        render: (text: number) => (
          <WizrText type='body2'>
            {new Date(text).toLocaleString('en-US', {
              month: 'short',
              day: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
              second: 'numeric',
              hour12: true,
            })}
          </WizrText>
        ),
      },
      {
        title: 'Duration Of Run',
        dataIndex: 'duration',
        key: 'duration',
        render: (text: number) => <WizrText type='body2'>{text} sec</WizrText>,
      },
      {
        title: 'Memory',
        width: 70,
        dataIndex: 'memory_required',
        key: 'memory_required',
        render: (text: string) => (
          <WizrText type='body4'>{text === 'true' ? 'True' : 'False'}</WizrText>
        ),
      },
      {
        title: 'Knowledge Base',
        width: 70,
        dataIndex: 'knowledgebase_required',
        key: 'knowledgebase_required',
        render: (text: string) => (
          <WizrText type='body4'>{text === 'true' ? 'True' : 'False'}</WizrText>
        ),
      },
      {
        title: 'Stop',
        width: 70,
        dataIndex: ['prompt_body', 'stop_sequences'],
        key: 'stop_sequences',
        render: (text: any) => (
          <div style={{ maxHeight: '200px', overflow: 'auto' }}>
            <WizrText type='body4'>{text && text.length > 0 ? text.join(', ') : 'NA'}</WizrText>
          </div>
        ),
      },
      {
        title: 'Presence Penalty',
        width: 70,
        dataIndex: ['prompt_body', 'presence_penalty'],
        key: 'presence_penalty',
        render: (text: string) => <WizrText type='body4'>{text}</WizrText>,
      },
      {
        title: 'Frequency Penalty',
        width: 70,
        dataIndex: ['prompt_body', 'frequency_penalty'],
        key: 'frequency_penalty',
        render: (text: string) => <WizrText type='body4'>{text}</WizrText>,
      },
      {
        title: 'Top P',
        width: 70,
        dataIndex: ['prompt_body', 'top_p'],
        key: 'top_p',
        render: (text: string) => <WizrText type='body4'>{text}</WizrText>,
      },
    ],
    AppTemplate: [
      {
        title: 'Name',
        dataIndex: 'app_name',
        key: 'app_name',
        render: (text: any, appDetail: any) => (
          <WizrFlexLayout flexDirection='coulmn' background='transparent' textAlign='left' alignItems='flex-start'>
            <WizrText type='body2'>{appDetail?.app_name}</WizrText>
            <WizrText type='caption'>{` Version ${appDetail?.app_version}`}</WizrText>
          </WizrFlexLayout>
        ),
        sorter: (a: any, b: any) => a.app_name.localeCompare(b.app_name),
      },
      {
        title: 'App Type',
        dataIndex: 'app_category',
        key: 'app_category',
        render: (text: string) => (
          <div style={{ maxHeight: '100px', overflow: 'auto', maxWidth: '600px' }}>
            <WizrText type='body2'>{text}</WizrText>
          </div>
        ),
      },
      {
        title: 'Description',
        dataIndex: 'description',
        key: 'description',
        width: 250,
        render: (text: string) => (
          <div style={{ maxHeight: '100px', overflow: 'auto', maxWidth: '600px' }}>
            <WizrText type='body2'>{text}</WizrText>
          </div>
        ),
      },
      {
        title: 'Tags',
        dataIndex: 'tags',
        key: 'tags',
        render: (text: any) => (
          <div style={{ maxHeight: '100px', overflow: 'auto', maxWidth: '600px' }}>
            <WizrTag
              checkable={false}
              data={text?.length > 0 && text[0] !== null ? text : null}
              type='colorfull'
            />
          </div>
        ),
        //sorter: (a: any, b: any) => (a.tags?.length || 0) - (b.tags?.length || 0),
      },
      {
        title: 'Owner',
        dataIndex: 'user_name',
        key: 'user_name',
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>,

        sorter: (a: any, b: any) => a.user_name.localeCompare(b.user_name),
      },
      {
        title: 'Updated On',
        dataIndex: 'updated_on',
        key: 'updated_on',
        render: (text: number) => (
          <WizrText type='body2'>
            {new Date(text).toLocaleString('en-US', {
              month: 'short',
              day: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
              hour12: true,
            })}
          </WizrText>
        ),
        sorter: (a: any, b: any) => a.updated_on - b.updated_on,
      },
      {
        title: '',
        dataIndex: 'published',
        key: 'published',
        width: 90,
        render: (text: boolean, appDetail: any) => text && <AppRun appDetail={appDetail} />
      },
      {
        title: '',
        dataIndex: '',
        width: 90,
        render: (text: any, appDetail: any) => <AppActionPopOver detail={appDetail} type='template' />,
      },
    ],
    App: [
      {
        title: 'Name',
        dataIndex: 'app_name',
        key: 'app_name',
        align: 'left',
        render: (text: any, appDetail: any) => (
          <WizrFlexLayout flexDirection='coulmn' background='transparent' textAlign='left' alignItems='flex-start'>
            <WizrText type='body2'>{appDetail?.app_name}</WizrText>
            <WizrText type='caption'>{` Version ${appDetail?.app_version}`}</WizrText>
          </WizrFlexLayout>
        ),
        sorter: (a: any, b: any) => a.appDetail?.app_name.localeCompare(b.appDetail?.app_name),
      },

      {
        title: 'Description',
        dataIndex: 'description',
        key: 'description',
        width: 250,
        render: (text: string) => (
          <ScrollableTagsContainer>
            <WizrText type='body2'>{text}</WizrText>
          </ScrollableTagsContainer>
        ),
      },
      {
        title: 'Status',
        dataIndex: 'published',
        key: 'published',
        render: (text: boolean) => (
          <WizrTag
            background={text ? '#22C55E' : '#EF4444'}
            data={text ? ['ACTIVE'] : ['INACTIVE']}
            textType='caption_small_bold'
            borderradius='4px'
          />
        ),
      },
      {
        title: 'Tags',
        dataIndex: 'tags',
        key: 'tags',
        render: (text: any) => (
          <ScrollableTagsContainer>
            <WizrTag
              checkable={false}
              data={text?.length > 0 && text[0] !== null ? text : null}
              type='colorfull'
            />
          </ScrollableTagsContainer>
        ),
        //sorter: (a: any, b: any) => (a.tags?.length || 0) - (b.tags?.length || 0),
      },
      {
        title: 'Owner',
        dataIndex: 'user_name',
        key: 'user_name',
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>,

        sorter: (a: any, b: any) => a.user_name.localeCompare(b.user_name),
      },
      {
        title: 'Updated On',
        dataIndex: 'updated_on',
        key: 'updated_on',
        render: (text: number) => (
          <WizrText type='body2'>
            {new Date(text).toLocaleString('en-US', {
              month: 'short',
              day: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
              hour12: true,
            })}
          </WizrText>
        ),
        sorter: (a: any, b: any) => a.updated_on - b.updated_on,
      },
      {
        title: '',
        dataIndex: 'published',
        key: 'published',
        width: 90,
        render: (text: boolean, appDetail: any) => text && <AppRun appDetail={appDetail} />,
      },
      {
        title: '',
        dataIndex: '',
        width: 90,
        render: (text: any, appDetail: any) => (
          <AppActionPopOver detail={appDetail} type='published' />
        ),
      },
    ],
    AppDraft: [
      {
        title: 'Name',
        dataIndex: 'app_name',
        key: 'app_name',
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>,
        sorter: (a: any, b: any) => a.app_name.localeCompare(b.app_name),
      },

      {
        title: 'Description',
        dataIndex: 'description',
        key: 'description',
        width: 250,
        render: (text: string) => (
          <div style={{ maxHeight: '100px', overflow: 'auto', maxWidth: '600px' }}>
            <WizrText type='body2'>{text}</WizrText>
          </div>
        ),
      },
      {
        title: 'Tags',
        dataIndex: 'tags',
        key: 'tags',
        render: (text: any) => (
          <div style={{ maxHeight: '100px', overflow: 'auto', maxWidth: '600px' }}>
            <WizrTag
              checkable={false}
              data={text?.length > 0 && text[0] !== null ? text : null}
              type='colorfull'
            />
          </div>
        ),
        //sorter: (a: any, b: any) => (a.tags?.length || 0) - (b.tags?.length || 0),
      },
      {
        title: 'Owner',
        dataIndex: 'user_name',
        key: 'user_name',
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>,

        sorter: (a: any, b: any) => a.user_name.localeCompare(b.user_name),
      },
      {
        title: 'Updated On',
        dataIndex: 'updated_on',
        key: 'updated_on',
        render: (text: number) => (
          <WizrText type='body2'>
            {new Date(text).toLocaleString('en-US', {
              month: 'short',
              day: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
              hour12: true,
            })}
          </WizrText>
        ),
        sorter: (a: any, b: any) => a.updated_on - b.updated_on,
      },
      {
        title: '',
        dataIndex: '',
        width: 90,
        render: (text: any, appDetail: any) => <AppActionPopOver detail={appDetail} type='draft' />,
      },
    ],
    AppMaster: [
      {
        title: 'Name',
        dataIndex: 'app_name',
        key: 'app_name',
        align: 'left',
        render: (text: any, appDetail: any) => (
          <WizrFlexLayout flexDirection='coulmn' background='transparent' textAlign='left' alignItems='flex-start'>
            <WizrText type='body2'>{appDetail?.app_name}</WizrText>
            <WizrText type='caption'>{` Version ${appDetail?.app_version}`}</WizrText>
          </WizrFlexLayout>
        ),
        sorter: (a: any, b: any) => a.appDetail?.app_name.localeCompare(b.appDetail?.app_name),
      },
      {
        title: 'App Type',
        dataIndex: 'app_category',
        key: 'app_category',
        render: (text: string) => (
          <div style={{ maxHeight: '100px', overflow: 'auto', maxWidth: '600px' }}>
            <WizrText type='body2'>{text}</WizrText>
          </div>
        ),
      },
      {
        title: 'Description',
        dataIndex: 'description',
        key: 'description',
        width: 250,
        render: (text: string) => (
          <div style={{ maxHeight: '100px', overflow: 'auto', maxWidth: '600px' }}>
            <WizrText type='body2'>{text}</WizrText>
          </div>
        ),
      },
      {
        title: 'Status',
        dataIndex: 'published',
        key: 'published',
        render: (text: boolean) => (
          <WizrTag
            background={text ? '#22C55E' : '#EF4444'}
            data={text ? ['ACTIVE'] : ['INACTIVE']}
            textType='caption_small_bold'
            borderradius='4px'
          />
        ),
      },
      {
        title: 'Tags',
        dataIndex: 'tags',
        key: 'tags',
        render: (text: any) => (
          <div style={{ maxHeight: '100px', overflow: 'auto', maxWidth: '600px' }}>
            <WizrTag
              checkable={false}
              data={text?.length > 0 && text[0] !== null ? text : null}
              type='colorfull'
            />
          </div>
        ),
        //sorter: (a: any, b: any) => (a.tags?.length || 0) - (b.tags?.length || 0),
      },
      {
        title: 'Owner',
        dataIndex: 'user_name',
        key: 'user_name',
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>,

        sorter: (a: any, b: any) => a.user_name.localeCompare(b.user_name),
      },
      {
        title: 'Updated On',
        dataIndex: 'updated_on',
        key: 'updated_on',
        render: (text: number) => (
          <WizrText type='body2'>
            {new Date(text).toLocaleString('en-US', {
              month: 'short',
              day: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
              hour12: true,
            })}
          </WizrText>
        ),
        sorter: (a: any, b: any) => a.updated_on - b.updated_on,
      },
      {
        title: '',
        dataIndex: 'published',
        key: 'published',
        width: 90,
        render: (text: boolean, appDetail: any) => text && <AppRun appDetail={appDetail} />,
      },
      {
        title: '',
        dataIndex: '',
        width: 90,
        render: (text: any, appDetail: any) => (
          <AppActionPopOver detail={appDetail} type='published' />

        ),
      },
    ],
    AppDraftMaster: [
      {
        title: 'Name',
        dataIndex: 'app_name',
        key: 'app_name',
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>,
        sorter: (a: any, b: any) => a.app_name.localeCompare(b.app_name),
      },
      {
        title: 'App Type',
        dataIndex: 'app_category',
        key: 'app_category',
        render: (text: string) => (
          <div style={{ maxHeight: '100px', overflow: 'auto', maxWidth: '600px' }}>
            <WizrText type='body2'>{text}</WizrText>
          </div>
        ),
      },
      {
        title: 'Description',
        dataIndex: 'description',
        key: 'description',
        width: 250,
        render: (text: string) => (
          <div style={{ maxHeight: '100px', overflow: 'auto', maxWidth: '600px' }}>
            <WizrText type='body2'>{text}</WizrText>
          </div>
        ),
      },
      {
        title: 'Tags',
        dataIndex: 'tags',
        key: 'tags',
        render: (text: any) => (
          <div style={{ maxHeight: '100px', overflow: 'auto', maxWidth: '600px' }}>
            <WizrTag
              checkable={false}
              data={text?.length > 0 && text[0] !== null ? text : null}
              type='colorfull'
            />
          </div>
        ),
        //sorter: (a: any, b: any) => (a.tags?.length || 0) - (b.tags?.length || 0),
      },
      {
        title: 'Owner',
        dataIndex: 'user_name',
        key: 'user_name',
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>,

        sorter: (a: any, b: any) => a.user_name.localeCompare(b.user_name),
      },
      {
        title: 'Updated On',
        dataIndex: 'updated_on',
        key: 'updated_on',
        render: (text: number) => (
          <WizrText type='body2'>
            {new Date(text).toLocaleString('en-US', {
              month: 'short',
              day: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
              hour12: true,
            })}
          </WizrText>
        ),
        sorter: (a: any, b: any) => a.updated_on - b.updated_on,
      },
      {
        title: '',
        dataIndex: '',
        width: 90,
        render: (text: any, appDetail: any) => <AppActionPopOver detail={appDetail} />,
      },
    ],
    apphistory: [
      {
        title: 'User Input',
        width: 190,
        dataIndex: ['app_input', 'message_params'],
        key: 'message_params',
        render: (text: any) => {
          if (!text || typeof text !== 'object') {
            return <WizrText type='body4'>{text ?? 'N/A'}</WizrText>
          }
          return (
            <div style={{ maxHeight: '200px', overflow: 'auto' }}>
              {Object.entries(text).map(([key, value]) => (
                <div key={key}>
                  <WizrText type='body4'>{key}</WizrText> : <WizrText type='body4'>
                    {typeof value === 'object' && value !== null ? JSON.stringify(value) : String(value ?? 'N/A')}
                  </WizrText>
                </div>
              ))}
            </div>
          )
        },
      },
      {
        title: 'End output',
        width: 350,
        dataIndex: 'output',
        key: 'output',
        render: (text: any) => (
          <div
            style={{
              maxHeight: '200px',
              overflow: 'auto',
              whiteSpace: 'pre-wrap',
              overflowWrap: 'break-word',
            }}
          >
            <WizrText type='body4'>{typeof text === 'object' && text !== null ? JSON.stringify(text) : String(text ?? 'N/A')}</WizrText>
          </div>
        ),
      },
      {
        title: 'Output format',
        width: 70,
        dataIndex: 'output_format',
        key: 'output_format',
        render: (text: string) => <WizrText type='body4'>{text}</WizrText>,
      },
      {
        title: 'Time of Run',
        width: 100,
        dataIndex: 'run_time',
        key: 'run_time',
        render: (text: number) => (
          <WizrText type='body2'>
            {new Date(text).toLocaleString('en-US', {
              month: 'short',
              day: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
              second: 'numeric',
              hour12: true,
            })}
          </WizrText>
        ),
      },
      {
        title: 'Time of Response',
        width: 60,
        dataIndex: 'response_time',
        key: 'response_time',
        render: (text: number) => (
          <WizrText type='body2'>
            {new Date(text).toLocaleString('en-US', {
              month: 'short',
              day: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
              second: 'numeric',
              hour12: true,
            })}
          </WizrText>
        ),
      },
      {
        title: 'Duration of Response',
        width: 60,
        dataIndex: 'duration',
        key: 'duration',
        render: (text: number) => <WizrText type='body2'>{text} sec</WizrText>,
      },
      {
        title: 'Type',
        width: 70,
        dataIndex: 'execution_status_id',
        key: 'execution_status_id',
        render: (text: string) => (
          <WizrText type='body4'>{text ? 'Bulk Run' : 'Single Run'}</WizrText>
        ),
      },
      {
        title: 'Error',
        width: 100,
        dataIndex: 'error_message',
        key: 'error_message',
        render: (text: string) => (
          <div style={{ maxHeight: '100px', overflow: 'auto', maxWidth: '600px' }}>
            <WizrText type='body4'>{text || 'No errors'}</WizrText>
          </div>
        ),
      },
      {
        title: 'Version',
        width: 70,
        dataIndex: 'app_version',
        key: 'app_version',
        render: (text: string) => <WizrText type='body4'>{text}</WizrText>,
      },
      {
        title: 'User',
        width: 70,
        dataIndex: 'user_name',
        key: 'user_name',
        render: (text: string) => <WizrText type='body4'>{text}</WizrText>,
      },
      {
        title: 'Status',
        width: 70,
        dataIndex: 'status',
        key: 'status',
        render: (text: string) => <WizrText type='body4'>{text}</WizrText>,
      },
    ],
    autosolvetesthistory: [
      {
        title: 'Date',
        dataIndex: 'date',
        key: 'date',
        render: (text: any) => <WizrText type='body2'>{text}</WizrText>,
      },
      {
        title: 'User id',
        dataIndex: 'user_id',
        key: 'user_id',
        render: (text: any) => <WizrText type='body2'>{text}</WizrText>,
      },
      {
        title: 'Session Input',
        dataIndex: 'session_input',
        key: 'session_input',
        render: (text: any) => <WizrText type='body2'>{text}</WizrText>,
      },
      {
        title: 'Conversation id',
        dataIndex: 'conversation_id',
        key: 'conversation_id',
        render: (text: any) => <WizrText type='body2'>{text}</WizrText>,
      },
      {
        title: 'Duration',
        dataIndex: 'duration',
        key: 'duration',
        render: (text: any) => <WizrText type='body2'>{text}</WizrText>,
      },
      {
        title: 'Start Time',
        dataIndex: 'start_time',
        key: 'start_time',
        render: (text: any) => <WizrText type='body2'>{text}</WizrText>,
      },
      {
        title: '',
        key: 'actions',
        dataIndex: 'detailedLogs', // or any key you want
        render: (text: any) => text, // just render whatever is passed
      },
    ],
    autosolveevalshistory: [
      {
        title: 'Dataset Name',
        dataIndex: 'dataset_name',
        key: 'dataset_name',
        render: (text: any) => <WizrText type='body2'>{text}</WizrText>,
      },
      {
        title: 'Duration',
        dataIndex: 'duration',
        key: 'duration',
        render: (text: any) => <WizrText type='body2'>{text}</WizrText>,
      },
      {
        title: 'Start Time',
        dataIndex: 'start_time',
        key: 'start_time',
        render: (text: any) => <WizrText type='body2'>{text}</WizrText>,
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        render: (text: any) => text, // Render the WizrTag component
      },
      {
        title: 'Report',
        dataIndex: 'report',
        key: 'report',
        render: (text: any) => text, // Render the View link component
      },
    ],
    bulkrun: [
      {
        title: 'Id',
        dataIndex: 'id',
        key: 'id',
        render: (text: any, record: any, index: any) => index + 1,
      },
      {
        title: 'File Name',
        dataIndex: 'file_name',
        key: 'file_name',
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>,
      },
      {
        title: 'Time of Run',
        dataIndex: 'created_at',
        key: 'created_at',
        render: (text: number) => (
          <WizrText type='body2'>
            {new Date(text).toLocaleString('en-US', {
              month: 'short',
              day: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
              second: 'numeric',
              hour12: true,
            })}
          </WizrText>
        ),
      },
      {
        title: 'Processed Rows',
        dataIndex: 'total_rows',
        key: 'total_rows',
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>,
      },
      {
        title: 'Failed Rows',
        dataIndex: 'failed_rows',
        key: 'failed_rows',
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>,
      },
      {
        title: 'Errors',
        dataIndex: 'error_message',
        key: 'error_message',
        render: (text: string) => <WizrText type='body2'>{text || 'No errors'}</WizrText>,
      },
      {
        title: 'Status',
        dataIndex: 'execution_status',
        key: 'execution_status',
        // render: (text:string) => (
        //   <WizrText type='body2'>{text}</WizrText>
        // ),
        render: (text: any) => {
          let backgroundColor;
          if (text === 'Completed') {
            backgroundColor = '#22C55E';
          } else if (text === 'in_progress') {
            backgroundColor = '#FBBF24';
          } else {
            backgroundColor = '#E5E7EB';
          }
          return (
            <WizrTag
              borderradius='4px'
              checkable={false}
              background={backgroundColor}
              data={[text]}
            />
          );
        },
      },
      {
        title: 'Time Taken',
        dataIndex: 'duration',
        key: 'duration',
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>,
      },
      {
        title: ' User Name',
        dataIndex: 'user_name',
        key: 'user_name',
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>,
      },
      {
        title: 'Output',
        width: '400px',
        dataIndex: 'output_file_name',
        key: 'output_file_name',
        render: (text: string, appDetail: any) => (
          // <WizrText type='body2'>{text}</WizrText>
          <BulkRunDownload fileName={appDetail} />
        ),
      },
    ],
    tenants: [
      {
        title: 'Tenant Name',
        dataIndex: 'tenant_name',
        key: 'tenant_name',
        render: (text: string) => <WizrAvatar name={text} background='transparent'></WizrAvatar>,
        sorter: (a: any, b: any) => a.tenant_name.localeCompare(b.tenant_name),
      },

      {
        title: 'Type',
        dataIndex: 'tenant_type',
        key: 'tenant_type',
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>,
      },
      {
        title: 'Product',
        dataIndex: 'product_name',
        key: 'product_name',
        render: (text: boolean) => <WizrText type='body2'>{text}</WizrText>,
      },
      {
        title: 'Region',
        dataIndex: 'region',
        key: 'region',
        render: (text: any) => <WizrText type='body2'>{text}</WizrText>,
        //sorter: (a: any, b: any) => (a.tags?.length || 0) - (b.tags?.length || 0),
      },
      {
        title: 'Domain',
        dataIndex: 'user_domains',
        key: 'user_domains',
        render: (text: string[]) => {
          const isValidText = text != null && text.length > 0 && text[0] != null;
          const displayText = isValidText ? text : [];
          return (
            <WizrTag
              checkable={false}
              data={displayText}
              type='colorfull'
            />
          );
        },
        sorter: (a: any, b: any) => a.user_domains.localeCompare(b.user_domains),
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        width: 100,
        render: (text: string) => (
          <WizrTag
            background={text === 'active' ? '#22C55E' : '#EF4444'}
            data={text === 'active' ? ['ACTIVE'] : ['DISABLED']}
            textType='caption_small_bold'
            borderradius='4px'
          />
        ),

        // sorter: (a: any, b: any) => a.user_name.localeCompare(b.user_name),
      },
      {
        title: 'Created on',
        dataIndex: 'created_on',
        key: 'created_on',
        render: (text: number) => (
          <WizrText type='body2'>
            {new Date(text).toLocaleString('en-US', {
              month: 'short',
              day: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
              hour12: true,
            })}
          </WizrText>
        ),
        sorter: (a: any, b: any) => a.updated_on - b.updated_on,
      },

      {
        title: '',
        dataIndex: '',
        width: 90,
        render: (text: any, tenantDetails: any) => (
          <TenantActionPopOver tenantDetails={tenantDetails} />
        ),
      },
    ],
    users: [
      {
        title: 'Name',
        dataIndex: 'displayName',
        key: 'displayName',
        render: (text: string) => <WizrAvatar name={text} background='transparent'></WizrAvatar>,
        sorter: (a: any, b: any) => a.displayName.localeCompare(b.displayName),
      },

      {
        title: 'Email',
        dataIndex: 'mail',
        key: 'mail',
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>,
      },
      {
        title: 'Mobile',
        width: 130,
        dataIndex: 'mobilePhone',
        key: 'mobilePhone',
        render: (text: boolean) => <WizrText type='body2'>{text}</WizrText>,
      },
      {
        title: 'Team',
        dataIndex: '',
        key: '',
        width: 130,
        render: (text: any, userDetails: { [key: string]: any }) => {
          const userTeamsKey = Object.keys(userDetails).find((key) => key.includes('UserTeams'))
          if (userTeamsKey !== undefined) {
            const userTeamsValue = userDetails[userTeamsKey]
            if (userTeamsValue && userTeamsValue.trim() !== '') {
              return (
                <WizrFlexLayout flexDirection='row' justifyContent='flex-start' alignItems='center' style={{ gap: '8px' }} background='transparent'>
                  <EndUser stroke={'black'} />
                  <WizrText type='body2'>{userTeamsValue}</WizrText>
                </WizrFlexLayout>
              )
            }
          }
          return <WizrText type='body2'>No team assigned</WizrText>
        },
      },
      {
        title: 'Role',
        dataIndex: '',
        key: '',
        width: 130,

        render: (text: any, userDetails: { [key: string]: any }) => {
          const userRoleKey = Object.keys(userDetails).find((key) => key.includes('UserRole'))
          if (userRoleKey !== undefined) {
            const userRoleValue = userDetails[userRoleKey]

            return <WizrText type='body2'>{userRoleValue}</WizrText>
          }
        },
        //sorter: (a: any, b: any) => (a.tags?.length || 0) - (b.tags?.length || 0),
      },
      {
        title: 'Tenant Name',
        //width:180,
        dataIndex: 'tenant_name',
        key: 'tenant_name',
        render: (text: any) => <WizrText type='body2'>{text}</WizrText>,

        //sorter: (a: any, b: any) => (a.tags?.length || 0) - (b.tags?.length || 0),
      },
      {
        title: 'Status',
        dataIndex: 'accountEnabled',
        width: 100,
        key: 'accountEnabled',
        filterIcon: getStatusFilterIcon,
        filterDropdown: getStatusFilterDropdown,
        onFilter: getStatusFilter,
        render: getStatusRender,
      },
      {
        title: 'Created on',
        width: 150,
        dataIndex: 'createdDateTime',
        key: 'createdDateTime',
        render: (text: number) => (
          <WizrText type='body2'>
            {new Date(text).toLocaleString('en-US', {
              month: 'short',
              day: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
              hour12: true,
            })}
          </WizrText>
        ),
        sorter: (a: any, b: any) => a.createdDateTime - b.createdDateTime,
      },
      {
        title: "Last Logged in",
        dataIndex: ["signInActivity", "lastSignInDateTime"],
        key: "lastSignInDateTime",
        render: (text: string) => (
          <WizrText type="body2">
            {text
              ? new Date(text).toLocaleString('en-US', {
                month: 'short',
                day: 'numeric',
                hour: 'numeric',
                minute: '2-digit',
                hour12: true,
              })
              : 'Never'}
          </WizrText>
        ),
      },

      {
        title: '',
        dataIndex: '',
        width: 90,
        render: (text: any, userDetails: any) => <UserAction userDetails={userDetails} />,
      },
    ],
    billing: [
      {
        title: 'Date',
        dataIndex: 'date',
        key: 'date',
        render: (text: number) => (
          <WizrText type='body2'>
            {new Date(text).toLocaleString('en-US', {
              month: 'short',
              day: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
              hour12: true,
            })}
          </WizrText>
        ),
        sorter: (a: any, b: any) => a.date - b.date,
      },
      {
        title: 'Company',
        dataIndex: 'company',
        key: 'company',
        render: (text: string) => <WizrAvatar name={text} background='transparent'></WizrAvatar>,
        sorter: (a: any, b: any) => a.company.localeCompare(b.company),
      },

      {
        title: 'App',
        dataIndex: 'app',
        key: 'app',
        // width: 350,
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>,
      },
      {
        title: 'Model',
        dataIndex: 'model',
        key: 'model',
        render: (text: boolean) => <WizrText type='body2'>{text}</WizrText>,
      },
      {
        title: 'Input Taken',
        dataIndex: 'input',
        key: 'input',
        render: (text: any) => <WizrText type='body2'>{text}</WizrText>,
      },
      {
        title: 'Output Taken',
        dataIndex: 'output',
        key: 'output',
        render: (text: any) => <WizrText type='body2'>{text}</WizrText>,
      },
      {
        title: 'Requests',
        dataIndex: 'request',
        key: 'request',
        render: (text: any) => <WizrText type='body2'>{text}</WizrText>,
        sorter: (a: any, b: any) => a.request - b.request,
      },
      {
        title: 'Cost',
        dataIndex: 'cost',
        key: 'cost',
        render: (text: any) => <WizrText type='body2'>{text}</WizrText>,
        sorter: (a: any, b: any) => a.cost - b.cost,
      },
      {
        title: 'Price',
        dataIndex: 'price',
        key: 'price',
        render: (text: any) => <WizrText type='body2'>{text}</WizrText>,
        sorter: (a: any, b: any) => a.price - b.price,
      },
    ],
    invoice: [
      {
        title: 'Date',
        dataIndex: 'date',
        key: 'date',
        render: (text: number) => (
          <WizrText type='body2'>
            {new Date(text).toLocaleString('en-US', {
              month: 'short',
              day: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
              hour12: true,
            })}
          </WizrText>
        ),
        sorter: (a: any, b: any) => a.date - b.date,
      },
      {
        title: 'Company',
        dataIndex: 'company',
        key: 'company',
        render: (text: string) => <WizrAvatar name={text} background='transparent'></WizrAvatar>,
        filters: [
          { text: 'google', value: 'google' },
          { text: 'amazon', value: 'amazon' },
        ],
        onFilter: (value: string, record: any) => {
          return record.company === value
        },
      },

      {
        title: 'Invoice',
        dataIndex: 'invoice',
        key: 'invoice',
        width: 350,
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>,
      },
      {
        title: 'Recepient',
        dataIndex: 'recepient',
        key: 'recepient',
        render: (text: boolean) => <WizrText type='body2'>{text}</WizrText>,
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        render: (text: any) => <WizrText type='body2'>{text}</WizrText>,
      },
      {
        title: 'Amount',
        dataIndex: 'amount',
        key: 'amount',
        render: (text: any) => <WizrText type='body2'>{text}</WizrText>,
      },
      {
        title: 'Paid On',
        dataIndex: 'paid',
        key: 'paid',
        render: (text: number) => (
          <WizrText type='body2'>
            {new Date(text).toLocaleString('en-US', {
              month: 'short',
              day: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
              hour12: true,
            })}
          </WizrText>
        ),
        sorter: (a: any, b: any) => a.paid.localeCompare(b.paid),
      },
    ],
    products: [
      {
        title: 'Name',
        dataIndex: 'product_name',
        width: 150,
        key: 'product_name',
        render: (text: boolean) => <WizrText type='body2'>{text}</WizrText>,
      },
      {
        title: 'AI Models',
        dataIndex: 'llm_model_details',
        key: 'llm_model_details',
        render: (text: string[]) => {
          const data = (text ?? []).map((item: any) => item?.display_name)

          return (
            <WizrTag
              type='colorfull'
              checkable={false}
              data={data !== null && data.length > 0 && data[0] !== null ? data : []}
            />
          )
        },
      },
      {
        title: 'Number of calls ',
        dataIndex: 'calls_count',
        key: 'calls_count',
        render: (text: string[]) => <WizrText type='body2'>{text}</WizrText>,
      },
      // {
      //   title: 'Access ',
      //   dataIndex: 'access_privileges',
      //   key: 'access_privileges',
      //   render: (text: string[]) => {
      //     const resultString = text.join(', ')

      //     return (
      //       <div style={{ overflow: 'hidden' }}>
      //         <WizrText type='body2'>{resultString}</WizrText>
      //       </div>
      //     )
      //   },
      // },
      {
        title: '',
        dataIndex: '',
        render: (text: any, productDetails: any) => (
          <ProductActionPopOver productDetails={productDetails} />
        ),
      },
    ],
    roles: [
      {
        title: 'Role ',
        width: 250,
        dataIndex: 'role_name',
        key: 'role_name',
        render: (text: boolean) => <WizrText type='body2'>{text}</WizrText>,
      },
      {
        title: 'Created On',
        dataIndex: 'created_on',
        key: 'created_on',
        render: (text: string) =>
          <WizrText type='caption2'>
            {new Date(text).toLocaleString('en-US', {
              month: 'short',
              day: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
              hour12: true,
            })}
          </WizrText>
        ,
      },
      {
        title: '',
        dataIndex: '',
        width: 90,
        render: (text: any, rolesDetails: any) => <RolesActionPopover rolesDetails={rolesDetails} />,
      },
    ],
    packages: [
      {
        title: 'Name ',
        dataIndex: 'package_name',
        key: 'package_name',
        width: 300,
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>,
      },
      {
        title: 'Apps ',
        dataIndex: 'app_details',
        key: 'app_details',
        render: (text: string[]) => {
          const appNames = text?.map((item: any) => item?.app_name)

          return (
            <div>
              <WizrTag
                type='colorfull'
                checkable={false}
                data={
                  appNames && appNames !== null && appNames.length > 0 && appNames[0] !== null
                    ? appNames
                    : []
                }
              />{' '}
            </div>
          )
        },
      },
      {
        title: '',
        dataIndex: '',
        width: 90,
        render: (text: any, packageDetails: any) => (
          <PackageActionPopOver packageDetails={packageDetails} />
        ),
      },
    ],
    integrations: [
      {
        title: <WizrText type='sub2'>Name</WizrText>,
        dataIndex: 'display_name',
        key: 'display_name',
        width: 300,
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>,
      },
      {
        title: <WizrText type='sub2'>Tool</WizrText>,
        dataIndex: '',
        key: '',
        render: (text: any) => {
          const getIntegrationIconComponent = (integrationKey: string) => {
            switch (integrationKey) {
              case 'zendesk':
                return <ZendeskIcon />;
              case 'freshdesk':
                return <Freshdesk />;
              case 'salesforce':
                return <Salesforce />;
              case 'confluence':
                return <ConfluenceIcon />;
              case 'jira':
                return <JiraIcon />;
              case 'slack':
                return <SlackIcon />;
              case 'sharepoint':
                return <SharepointIcon />;
              case 'servicenow':
                return <ServiceNowIcon />;
              case 'postgres':
                return <PostgreSQLIcon />;
              case 'gemini':
                return <Gemini />;
              case 'pinecone':
                return <Pinecone />;
              case 'mongodb':
                return <MongoDBIcon />;
              case 'smtp':
                return <SendEmailIcon />;
              case 'pgvector':
                return <PgVectorIcon />;
              case 'milvus':
                return <MilvusIcon />;
              case 'qdrant':
                return <QdrantIcon />;
              case 'weaviate':
                return <WeaviateIcon />;
              default:
                return <div></div>;
            }
          };

          return (
            <WizrFlexLayout flexDirection='row' justifyContent='flex-start' alignItems='center ' style={{ gap: '10px' }} background='transparent'>
              {getIntegrationIconComponent(text?.integration_key)}
              <WizrText type='body2'>{text?.integration_display_name}</WizrText>
            </WizrFlexLayout>
          );
        },
      },
      {
        title: <WizrText type='sub2'>Email</WizrText>,
        dataIndex: 'registered_emailid',
        key: 'registered_emailid',
        render: (text: string, record: any) => (
          record?.integration_key === 'slack' || record?.integration_key === 'servicenow' || record?.integration_key === 'postgres' || record?.integration_key === 'smtp' ?
            <WizrText type='body2'>Not Required</WizrText> :
            <WizrText type='body2'>{text}</WizrText>
        ),
      },
      {
        title: <WizrText type='sub2'>Integrated On</WizrText>,
        dataIndex: 'updated_on',
        key: 'updated_on',
        render: (text: any) => (
          <WizrText type='caption2'>
            {new Date(text).toLocaleString('en-US', {
              month: 'short',
              day: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
              hour12: true,
            })}
          </WizrText>
        ),
      },
      {
        title: '',
        dataIndex: '',
        width: 90,
        render: (text: any, integrationDetails: any) => (
          <IntegrationActionPopOver integrationDetails={integrationDetails} />
        ),
      },
    ],
    integrationsSettings: [
      {
        title: <WizrText type='sub2'>Name</WizrText>,
        dataIndex: 'display_name',
        key: 'display_name',
        width: 300,
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>
      },
      {
        title: <WizrText type='sub2'>Tool</WizrText>,
        dataIndex: 'integration_display_name',
        key: 'integration_display_name',
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>,
      },
      {
        title: <WizrText type='sub2'>Email</WizrText>,
        dataIndex: 'registered_emailid',
        key: 'registered_emailid',
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>,
      },
      {
        title: <WizrText type='sub2'>Integrated On</WizrText>,
        dataIndex: 'updated_on',
        key: 'updated_on',
        render: (text: any) => (
          <WizrText type='caption2'>
            {new Date(text).toLocaleString('en-US', {
              month: 'short',
              day: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
              hour12: true,
            })}
          </WizrText>
        ),
      },
    ],
    ai_db: [
      {
        title: <WizrText type='sub2'>Name</WizrText>,
        dataIndex: 'name',
        key: 'name',
        width: 220,
        sorter: (a: any, b: any) => (a.name || '').localeCompare(b.name || ''),
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>,
      },
      {
        title: <WizrText type='sub2'>LLM Type</WizrText>,
        dataIndex: 'type',
        key: 'type',
        sorter: (a: any, b: any) => (a.type || '').localeCompare(b.type || ''),
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>,
      },
      {
        title: <WizrText type='sub2'>API Version</WizrText>,
        dataIndex: 'version',
        key: 'version',
        sorter: (a: any, b: any) => (a.version || '').localeCompare(b.version || ''),
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>,
      },
      // {
      //   title: <WizrText type='sub2'>Type</WizrText>,
      //   dataIndex: 'entry_type',
      //   key: 'entry_type',
      //   width: 100,
      //   sorter: (a: any, b: any) => (a.entry_type || '').localeCompare(b.entry_type || ''),
      //   render: (text: string) => <WizrText type='body2'>{text}</WizrText>,
      // },
      {
        title: <WizrText type='sub2'>Updated On</WizrText>,
        dataIndex: 'updated_on',
        key: 'updated_on',
        sorter: (a: any, b: any) => (a.updated_on_ms ?? 0) - (b.updated_on_ms ?? 0),
        render: (_: unknown, record: any) => {
          const ms = typeof record?.updated_on_ms === 'number' ? record.updated_on_ms : 0
          let d: Date | null = null
          if (ms > 0) {
            d = new Date(ms)
          } else {
            const text = record?.updated_on as number | string | null | undefined
            if (text != null && text !== '' && text !== '-') {
              const parsed = new Date(text as string)
              if (!Number.isNaN(parsed.getTime())) d = parsed
            }
          }
          if (!d || Number.isNaN(d.getTime())) {
            return <WizrText type='caption2'>—</WizrText>
          }
          return (
            <WizrText type='caption2'>
              {d.toLocaleString('en-US', {
                month: 'short',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                hour12: true,
              })}
            </WizrText>
          )
        },
      },
      {
        title: <WizrText type='sub2'>Status</WizrText>,
        dataIndex: 'status',
        key: 'status',
        sorter: (a: any, b: any) => (a.status || '').localeCompare(b.status || ''),
        render: (text: string) => (
          <WizrText type='body2'>
            {String(text ?? '').toLowerCase() === 'disabled' ? 'Inactive' : text}
          </WizrText>
        ),
      },
      {
        title: '',
        dataIndex: 'moreAction',
        key: 'moreAction',
        width: 90,
        render: (_: unknown, record: any) => <LlmDbRowActionPopover record={record} />,
      },
    ],
    grouplisting: [
      {
        title: <WizrText type='sub2'>Name</WizrText>,
        render: (folderDetails: any) => (
          <WizrFlexLayout
            flexDirection='row'
            justifyContent='flex-start'
            alignContent='flex-start'
            background='transparent'
            flex='none'
          >
            <FolderIcon />
            <WizrText type='body2' style={{ padding: '3px' }}>{folderDetails?.folder_name}</WizrText>
          </WizrFlexLayout>
          // <WizrButton
          //   padding={'0px'}
          //   icon={<FolderIcon />}
          //   text={folderDetails?.folder_name}
          //   type='text'
          //   disabled={true}
          //   onClick={() => {
          //     routerHistory.navigate(`/featuregroup/${folderDetails?.group}/${folderDetails?.folder_id}`, {
          //       state: { files: folderDetails },
          //     })
          //   }}
          // />
        ),
      },
      {
        title: <WizrText type='sub2'>Created On</WizrText>,
        dataIndex: 'created_on',
        width: 190,
        // render: (folderDetails: any) => (
        //   <WizrButton
        //     padding={'0px'}
        //     text={folderDetails?.folder_name}
        //     type='text'
        //     onClick={() => {
        //       routerHistory.navigate(`/featuregroup/${folderDetails?.group}/${folderDetails?.folder_id}`, {
        //         state: { files: folderDetails },
        //       })
        //     }}
        //   />
        // ),

        render: (text: any) => (
          <WizrText type='caption2' >
            {new Date(text).toLocaleString('en-US', {
              month: 'short',
              day: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
              hour12: true,
            })}

          </WizrText>
        ),
        sorter: (a: any, b: any) => a.created_on - b.created_on,
      },
      {
        title: '',
        dataIndex: '',
        width: 90,
        render: (text: any, groupDetails: any) => (
          <GroupActionPopover groupDetails={groupDetails} />
        ),
      },
    ],
    intentcategorytable: [
      {
        title: <WizrText type='sub2'>Category</WizrText>,
        dataIndex: 'name',
        sorter: (a: any, b: any) => a.name.localeCompare(b.name),
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>,
      },
      {
        title: <WizrText type='sub2'>Intent</WizrText>,
        dataIndex: 'intent',
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>,
        sorter: (a: any, b: any) => a.intent.localeCompare(b.intent),

      },
      {
        title: <WizrText type='sub2'>Description</WizrText>,
        dataIndex: 'description',
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>,
        sorter: (a: any, b: any) => a.description.localeCompare(b.description),

      },
      {
        title: <WizrText type='sub2'>Date of create</WizrText>,
        dataIndex: 'created_on',
        render: (text: any) => (
          <WizrText type='caption2'>
            {new Date(text).toLocaleString('en-US', {
              month: 'short',
              day: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
              hour12: true,
            })}
          </WizrText>
        ),
        sorter: (a: any, b: any) => a.created_on - b.created_on

      },
      {
        title: '',
        dataIndex: '',
        width: 90,
        render: (text: any, details: any) => (
          <TicketActionPopover details={details} />),
      },
    ],
    tickettypetable: [
      {
        title: <WizrText type='sub2'>Ticket Type</WizrText>,
        dataIndex: 'name',
        sorter: (a: any, b: any) => a.name.localeCompare(b.name),
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>,
      },

      {
        title: <WizrText type='sub2'>Description</WizrText>,
        dataIndex: 'description',
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>,
        sorter: (a: any, b: any) => a.description.localeCompare(b.description),

      },
      {
        title: <WizrText type='sub2'>Date of create</WizrText>,
        dataIndex: 'created_on',
        render: (text: any) => (
          <WizrText type='caption2'>
            {new Date(text).toLocaleString('en-US', {
              month: 'short',
              day: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
              hour12: true,
            })}
          </WizrText>
        ),
        sorter: (a: any, b: any) => a.created_on - b.created_on,

      },
      {
        title: '',
        dataIndex: '',
        width: 90,
        render: (text: any, details: any) => (
          <TicketActionPopover details={details} />),
      },
    ],
    customfieldtable: [
      {
        title: <WizrText type='sub2'>Custom Field Name</WizrText>,
        dataIndex: 'name',
        sorter: (a: any, b: any) => a.name.localeCompare(b.name),
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>,
      },
      {
        title: <WizrText type='sub2'>Description</WizrText>,
        dataIndex: 'description',
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>,
        sorter: (a: any, b: any) => a.description.localeCompare(b.description),
      },
      {
        title: <WizrText type='sub2'>Date of create</WizrText>,
        dataIndex: 'created_on',
        render: (text: any) => (
          <WizrText type='caption2'>
            {new Date(text).toLocaleString('en-US', {
              month: 'short',
              day: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
              hour12: true,
            })}
          </WizrText>
        ),
        sorter: (a: any, b: any) => a.created_on - b.created_on,
      },
      {
        title: '',
        dataIndex: '',
        width: 90,
        render: (text: any, details: any) => (
          <TicketActionPopover details={details} />
        ),
      },
    ],


    agentperfomancetag: [
      {
        title: <WizrText type='sub2'>Ticket Type</WizrText>,
        dataIndex: 'name',
        sorter: (a: any, b: any) => a.name.localeCompare(b.name),
        render: (text: string) => <div style={{ maxHeight: '50px', overflow: 'auto', maxWidth: '600px' }}>
          <WizrText type='body2'>{text}</WizrText>
        </div>,
      },

      {
        title: <WizrText type='sub2'>Description</WizrText>,
        dataIndex: 'description',
        render: (text: string) => <div style={{ maxHeight: '50px', overflow: 'auto', maxWidth: '600px' }}>
          <WizrText type='body2'>{text}</WizrText>
        </div>,
        sorter: (a: any, b: any) => a.description.localeCompare(b.description),

      },
      {
        title: <WizrText type='sub2'>Output Format</WizrText>,
        width: 100,
        dataIndex: 'output_format',
        render: (text: string) => <div style={{ maxHeight: '50px', overflow: 'auto', maxWidth: '600px' }}>
          <WizrText type='body2'>{text}</WizrText>
        </div>,
        sorter: (a: any, b: any) => a.output_format.localeCompare(b.output_format),

      },
      {
        title: <WizrText type='sub2'>Date of create</WizrText>,
        width: 120,
        dataIndex: 'created_on',
        render: (text: any) => (
          <WizrText type='caption2'>
            {new Date(text).toLocaleString('en-US', {
              month: 'short',
              day: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
              hour12: true,
            })}
          </WizrText>
        ),
        sorter: (a: any, b: any) => a.created_on - b.created_on,

      },
      {
        title: '',
        dataIndex: '',
        width: 90,
        render: (text: any, details: any) => (
          <TicketActionPopover details={details} />),
      },
    ],
    sentimenttable: [
      {
        title: <WizrText type='sub2'>Sentiment</WizrText>,
        dataIndex: 'name',
        sorter: (a: any, b: any) => a.name.localeCompare(b.name),
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>,
      },

      {
        title: <WizrText type='sub2'>Description</WizrText>,
        dataIndex: 'description',
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>,
        sorter: (a: any, b: any) => a.description.localeCompare(b.description),

      },
      {
        title: <WizrText type='sub2'>Date of create</WizrText>,
        dataIndex: 'created_on',
        render: (text: any) => (
          <WizrText type='caption2'>
            {new Date(text).toLocaleString('en-US', {
              month: 'short',
              day: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
              hour12: true,
            })}
          </WizrText>
        ),
        sorter: (a: any, b: any) => a.created_on - b.created_on,

      },
      {
        title: '',
        dataIndex: '',
        width: 90,
        render: (text: any, details: any) => (
          <TicketActionPopover details={details} />),
      },
    ],
    tickettable: [
      {
        title: <WizrText type='sub2'>Values</WizrText>,
        dataIndex: 'name',
        sorter: (a: any, b: any) => a.name.localeCompare(b.name),
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>,
      },

      {
        title: <WizrText type='sub2'>Description</WizrText>,
        dataIndex: 'description',
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>,
        sorter: (a: any, b: any) => a.description.localeCompare(b.description),

      },
      {
        title: <WizrText type='sub2'>Date of create</WizrText>,
        dataIndex: 'created_on',
        render: (text: any) => (
          <WizrText type='caption2'>
            {new Date(text).toLocaleString('en-US', {
              month: 'short',
              day: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
              hour12: true,
            })}
          </WizrText>
        ),
        sorter: (a: any, b: any) => a.created_on - b.created_on,

      },
      {
        title: '',
        dataIndex: '',
        width: 90,
        render: (text: any, details: any) => (
          <TicketActionPopover details={details} />),
      },
    ],
    tagkeywordtable: [
      {
        title: <WizrText type='sub2'>Tag Name</WizrText>,
        dataIndex: 'name',
        sorter: (a: any, b: any) => a.name.localeCompare(b.name),
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>,
      },
      {
        title: <WizrText type='sub2'>Date of create</WizrText>,
        dataIndex: 'created_on',
        render: (text: any) => (
          <WizrText type='caption2'>
            {new Date(text).toLocaleString('en-US', {
              month: 'short',
              day: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
              hour12: true,
            })}
          </WizrText>
        ),
        sorter: (a: any, b: any) => a.created_on - b.created_on,

      },
      {
        title: '',
        dataIndex: '',
        width: 90,
        render: (text: any, details: any) => (
          <TicketActionPopover details={details} />),
      },
    ],
    persona: [
      {
        title: <WizrText type='sub2'>Name</WizrText>,
        dataIndex: 'name',
        sorter: (a: any, b: any) => a.name.localeCompare(b.name),
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>,
      },
      {
        title: <WizrText type='sub2'>Description</WizrText>,
        dataIndex: 'description',
        sorter: (a: any, b: any) => a.description.localeCompare(b.description),
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>,
      },
      {
        title: <WizrText type='sub2'>Language</WizrText>,
        dataIndex: 'language',
        sorter: (a: any, b: any) => a.language.localeCompare(b.language),
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>,
      },
      {
        title: <WizrText type='sub2'>Tone</WizrText>,
        dataIndex: 'tone',
        sorter: (a: any, b: any) => a.tone.localeCompare(b.tone),
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>,
      },
      {
        title: <WizrText type='sub2'>Length</WizrText>,
        dataIndex: 'length',
        sorter: (a: any, b: any) => a.length - b.length,
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>,
      },
      {
        title: <WizrText type='sub2'>Date of create</WizrText>,
        dataIndex: 'created_on',
        render: (text: any) => (
          <WizrText type='caption2'>
            {new Date(text).toLocaleString('en-US', {
              month: 'short',
              day: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
              hour12: true,
            })}
          </WizrText>
        ),
        sorter: (a: any, b: any) => a.created_on - b.created_on,

      },
      {
        title: '',
        dataIndex: '',
        width: 90,
        render: (text: any, persona: any) => (
          <PersonaActionPopOver persona={persona} />
        ),
      },
    ],
    customerHealth: [
      {
        title: <WizrText type='sub2'>Customer Name</WizrText>,
        dataIndex: '',
        sorter: (a: any, b: any) => a.customer.localeCompare(b.customer),
        render: (text: any, details: any) =>
          < CustomerHealthCustomerCard details={details} />,
      },
      {
        title: <WizrText type='sub2'>Overall Health</WizrText>,
        dataIndex: 'health',
        sorter: (a: any, b: any) => Number(a.health) - Number(b.health),
        render: (text: string) => <CustomerHealthRoundTag text={text} type='sentiment' />,
      },
      {
        title: <WizrText type='sub2'>Sentiment</WizrText>,
        dataIndex: 'sentiment',
        sorter: (a: any, b: any) => a.sentiment.localeCompare(b.sentiment),
        render: (text: string) => <CustomerHealthRoundTag text={text} type='sentiment' />,
      },
      {
        title: <WizrText type='sub2'>Escalations</WizrText>,
        dataIndex: 'escalation',
        sorter: (a: any, b: any) => Number(a.escalation) - Number(b.escalation),
        render: (text: string) => <CustomerHealthRoundTag text={text} type='escalation' />,
      },
      {
        title: <WizrText type='sub2'>Time to resolve</WizrText>,
        dataIndex: 'time_for_resolve',
        sorter: (a: any, b: any) => Number(a.time_for_resolve) - Number(b.time_for_resolve),
        render: (text: string) => <CustomerHealthRoundTag text={text} type='resolution' />,
      },
      {
        title: <WizrText type='sub2'>Total Tickets</WizrText>,
        dataIndex: 'total_tickets',
        sorter: (a: any, b: any) => Number(a.total_tickets) - Number(b.total_tickets),
        render: (text: string) => <TicketCountDisplay text={text} type='total_tickets' />,
      },
      {
        title: <WizrText type='sub2'>Open Tickets</WizrText>,
        dataIndex: 'open_tickets',
        sorter: (a: any, b: any) => Number(a.open_tickets) - Number(b.open_tickets),
        render: (text: string) => <TicketCountDisplay text={text} type='open_tickets' />,
      },
    ],
    appInsights: [
      {
        title: <WizrText type='sub2'>App Name</WizrText>,
        dataIndex: 'app_name',
        render: (text: string) => (
          <WizrFlexLayout justifyContent='flex-start' alignContent='center' alignItems='center' flexDirection='row' background='transparent' style={{ gap: '8px' }}>
            <WizrIcon name='sparkels' stroke="#1D1F22" />
            <WizrText type='body2'>{text}</WizrText>
          </WizrFlexLayout>
        ),
        filters: filerArrayAppname,
        filterSearch: true,
        onFilter: (value: any, record: any) => record.app_name.includes(value as string)
      },
      {
        title: <WizrText type='sub2'>App Id</WizrText>,
        dataIndex: 'app_id',
        // sorter: (a: any, b: any) => a.health.localeCompare(b.description),
        // render: (text: string) => (
        //   <div style={{ maxHeight: '100px', overflow: 'auto', maxWidth: '600px' }}>
        //     <WizrText type='body2'>{text}</WizrText>
        //   </div>
        //   ),
        filters: filerArrayAppId,
        filterSearch: true,
        onFilter: (value: any, record: any) => record.app_id.includes(value as string)
      },
      {
        title: <WizrText type='sub2'>Total Execution Count</WizrText>,
        dataIndex: 'executions',
        // sorter: (a: any, b: any) => a.sentiment.localeCompare(b.sentiment),
        // render: (text: string) => (
        //   <div style={{ maxHeight: '100px', overflow: 'auto', maxWidth: '600px' }}>
        //     <WizrText type='body2'>{text}</WizrText>
        //   </div>
        //   ), 
        // filters: filterValues,
        // filterSearch: true, 
      },
      {
        title: <WizrText type='sub2'>Average Time</WizrText>,
        dataIndex: 'total_execution_time',
        // sorter: (a: any, b: any) => a.escalation.localeCompare(b.escalation),
        // render: (text: string) => (
        //   <div style={{ maxHeight: '100px', overflow: 'auto', maxWidth: '600px' }}>
        //     <WizrText type='body2'>{text}</WizrText>
        //   </div>
        //   ), 
        // filters: filterValues,
        // filterSearch: true,
      },
      {
        title: <WizrText type='sub2'>Error Rate</WizrText>,
        dataIndex: 'error_rate',
        // sorter: (a: any, b: any) => a.time_for_resolve.localeCompare(b.time_for_resolve),
        render: (text: string) => (
          <div style={{ maxHeight: '100px', overflow: 'auto', maxWidth: '600px' }}>
            <WizrText type='body2'>{parseFloat(text).toFixed(2)}</WizrText>
          </div>
        ),
        // filters: filterValues,
        // filterSearch: true,
      },
      {
        title: '',
        dataIndex: '',
        width: 90,
        render: (text: any, appDetail: any) => <AppActionPopOver detail={appDetail} />,
      },

    ],
    appInsightsSingle: [
      {
        title: <WizrText type='sub2'>Date</WizrText>,
        dataIndex: 'data',
        // render: (text: string) => (
        //   <WizrFlexLayout justifyContent='flex-start' alignContent='center' alignItems='center' flexDirection='row' background='white' style={{gap: '8px' }}>
        //     <WizrIcon name='sparkels' stroke="#1D1F22" />
        //     <WizrText type='body2'>{text}</WizrText>
        //   </WizrFlexLayout>
        // ),
        filters: filerArrayAppname,
        filterSearch: true,
        // onFilter: (value: any, record: any) => record.app_name.includes(value as string)
      },
      {
        title: <WizrText type='sub2'>Version</WizrText>,
        dataIndex: 'version',
        // sorter: (a: any, b: any) => a.health.localeCompare(b.description),
        // render: (text: string) => (
        //   <div style={{ maxHeight: '100px', overflow: 'auto', maxWidth: '600px' }}>
        //     <WizrText type='body2'>{text}</WizrText>
        //   </div>
        //   ),
        filters: filerArrayAppId,
        // filterSearch: true,
        // onFilter: (value: any, record: any) => record.app_id.includes(value as string)
      },
      {
        title: <WizrText type='sub2'>Total Execution Count</WizrText>,
        dataIndex: 'executions',
        // sorter: (a: any, b: any) => a.sentiment.localeCompare(b.sentiment),
        // render: (text: string) => (
        //   <div style={{ maxHeight: '100px', overflow: 'auto', maxWidth: '600px' }}>
        //     <WizrText type='body2'>{text}</WizrText>
        //   </div>
        //   ), 
        filters: filterValues,
        // filterSearch: true, 
      },
      {
        title: <WizrText type='sub2'>Average Time</WizrText>,
        dataIndex: 'total_execution_time',
        // sorter: (a: any, b: any) => a.escalation.localeCompare(b.escalation),
        // render: (text: string) => (
        //   <div style={{ maxHeight: '100px', overflow: 'auto', maxWidth: '600px' }}>
        //     <WizrText type='body2'>{text}</WizrText>
        //   </div>
        //   ), 
        filters: filterValues,
        // filterSearch: true,
      },
      {
        title: <WizrText type='sub2'>Error Rate</WizrText>,
        dataIndex: 'error_rate',
        // sorter: (a: any, b: any) => a.time_for_resolve.localeCompare(b.time_for_resolve),
        // render: (text: string) => (
        //   <div style={{ maxHeight: '100px', overflow: 'auto', maxWidth: '600px' }}>
        //     <WizrText type='body2'>{parseFloat(text).toFixed(2)}</WizrText>
        //   </div>
        //   ),
        filters: filterValues,
        // filterSearch: true,
      },
      {
        title: '',
        dataIndex: '',
        width: 90,
        render: (text: any, appDetail: any) => <AppActionPopOver detail={appDetail} />,
      },

    ],
    scheduler: [
      {
        title: <WizrText type="sub2">Folder Name</WizrText>,
        dataIndex: 'folder_id',
        key: 'folder_id',
        render: (text: string, record: any) => (
          <WizrText type='body2'>
            {record.folder_name || 'No Folder'}
          </WizrText>
        )
      },
      {
        title: <WizrText type='sub2'>Tool</WizrText>,
        dataIndex: 'tool',
        key: 'tool',
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>,
      },
      {
        title: <WizrText type='sub2'>Integration</WizrText>,
        dataIndex: 'integration_display_name',
        key: 'integration_name',
        // render:(text: string) => <WizrText type='body2'>{text}</WizrText>,
        render: (text: string, record: any) => {

          return (
            <WizrText type='body2'>
              {record.integration_display_name || record.integration_name || 'No Integration'}
            </WizrText>
          );
        },
      },
      {
        title: <WizrText type='sub2'>Email Address</WizrText>,
        dataIndex: 'email_id',
        key: 'email_id',
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>,
      },
      {
        title: <WizrText type='sub2'>Repeated</WizrText>,
        dataIndex: 'repeat_duration',
        key: 'repeat_duration',
        render: (text: string) => (<WizrText type='body2'>{text || 'Not Repeated'}</WizrText>),
      },
      {
        title: <WizrText type='sub2'>Date Range</WizrText>,
        dataIndex: '',
        key: 'date_range',
        render: (text: any) => {
          // Convert UTC date strings to local Date objects
          const startDate = new Date(text?.import_start_date || text?.scheduler_start_date);
          const endDate = new Date(text?.import_end_date || text?.scheduler_end_date);

          // Function to format Date objects to a readable string
          const formatDate = (date: Date) => {
            if (isNaN(date.getTime())) return ''; // Check for invalid dates
            const day = date.getDate();
            const month = date.toLocaleString('en-US', { month: 'short' });
            const year = date.getFullYear().toString().slice(-2);
            return `${day} ${month}'${year}`;
          };

          return (
            <WizrText type='body2'>
              {`${formatDate(startDate)} - ${formatDate(endDate)}`}
            </WizrText>
          );
        }
      },
      {
        title: <WizrText type='sub2'>Last Run </WizrText>,
        dataIndex: 'last_run_time',
        key: 'last_run_time',
        render: (text: any) => (
          <WizrText type='body2'>
            {text
              ? new Date(text).toLocaleString('en-US', {
                month: 'short',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                hour12: true,
              })
              : 'N/A'}
          </WizrText>
        ),
      },
      {
        title: '',
        dataIndex: '',
        width: 90,
        render: (text: any, details: any) => (
          <SchedulerActionPopover details={details} />),
      },
    ],
    schedulerHistory: [
      {
        title:
          <WizrText style={{ background: '000000 ' }} type='sub2'>Folder Name</WizrText>,
        dataIndex: 'folder_name',
        key: 'folder_name',
        render: (text: string, record: any) => (
          <WizrText type='body2'>
            {record.folder_name || 'No Folder'}
          </WizrText>
        )
      },
      {
        title: <WizrText type='sub2'>Integration</WizrText>,
        dataIndex: 'integration',
        key: 'integration',
        render: (text: string, record: any) =>
          <WizrText type='body2'>{record?.integration}</WizrText>
      },
      {
        title: <WizrText type='sub2'>Time of Run</WizrText>,
        dataIndex: 'run_start_time',
        key: 'run_start_time',
        render: (text: string, record: any) => {
          const date = new Date(record?.run_start_time);
          const formattedDate = date.toLocaleString('en-US', {
            month: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            hour12: true,
          });
          return <WizrText type='body2'>{formattedDate}</WizrText>;
        }
      },
      {
        title: <WizrText type='sub2'>Status</WizrText>,
        dataIndex: 'status',
        key: 'status',
        render: (text: string, record: any) => {

          let backgroundColor;

          switch (record?.status?.toLowerCase()) {
            case 'failed':
            case 'fail':
              backgroundColor = '#EF4444';
              break;
            case 'processing':
            case 'in progress':
              backgroundColor = '#FBBF24';
              break;
            case 'success':
            case 'completed':
              backgroundColor = '#22C55E';
              break;
            default:
              backgroundColor = '#991B1B';
          }

          return (
            <WizrTag
              background={backgroundColor}
              data={[record?.status]}
              borderradius="4px"
            />
          );
        },
      },
      {
        title: <WizrText type='sub2'>Error</WizrText>,
        dataIndex: 'error',
        key: 'error',
        render: (text: string, record: any) => <WizrText type='body2'>{record?.error}</WizrText>
      },
      {
        title: <WizrText type='sub2'>Start Date</WizrText>,
        dataIndex: 'start_date',
        key: 'start_date',
        render: (text: string, record: any) => {
          const date = new Date(record?.start_date);
          const formattedDate = date.toLocaleString('en-US', {
            month: 'short',
            day: 'numeric',
          });
          return <WizrText type='body2'>{formattedDate}</WizrText>;
        }
      },
      {
        title: <WizrText type='sub2'>End Date</WizrText>,
        dataIndex: 'end_date',
        key: 'end_date',
        render: (text: string, record: any) => {
          const date = new Date(record?.end_date);
          const formattedDate = date.toLocaleString('en-US', {
            month: 'short',
            day: 'numeric',
          });
          return <WizrText type='body2'>{formattedDate}</WizrText>;
        }
      },
      {
        title: <WizrText type='sub2'>Owner</WizrText>,
        dataIndex: 'owner',
        key: 'owner',
        render: (text: string, record: any) => <WizrText type='body2'>{record?.owner}</WizrText>
      }
    ],
    agentInsights: [
      {
        title: 'Name',
        dataIndex: 'folder_name',
        key: 'folder_name',
        sorter: (a: any, b: any) => a.folder_name.localeCompare(b.folder_name),
        render: (text: string, folderDetail: any) => (
          <WizrText type='body2'>varun</WizrText>
        ),
      },
      {
        title: 'Resolution Time',
        dataIndex: 'owner',
        key: 'owner',
        sorter: (a: any, b: any) => a.user_name.localeCompare(b.user_name),
        render: (text: string, folderDetail: any) => (
          <WizrText type='body2'>65%</WizrText>
        ),
      },
      {
        title: 'Avg Resolution Time',
        dataIndex: 'owner',
        key: 'owner',
        sorter: (a: any, b: any) => a.user_name.localeCompare(b.user_name),
        render: (text: string, folderDetail: any) => (
          <WizrText type='body2'>8hrs 30min</WizrText>
        ),
      },
      {
        title: 'Avg Response Rate',
        dataIndex: 'owner',
        key: 'owner',
        sorter: (a: any, b: any) => a.user_name.localeCompare(b.user_name),
        render: (text: string, folderDetail: any) => (
          <WizrText type='body2'>30m</WizrText>
        ),
      },
      {
        title: 'Tickets Assigned',
        dataIndex: 'owner',
        key: 'owner',
        sorter: (a: any, b: any) => a.user_name.localeCompare(b.user_name),
        render: (text: string, folderDetail: any) => (
          <WizrText type='body2'>1000</WizrText>
        ),
      },
      {
        title: 'Tickets Pending',
        dataIndex: 'owner',
        key: 'owner',
        sorter: (a: any, b: any) => a.user_name.localeCompare(b.user_name),
        render: (text: string, folderDetail: any) => (
          <WizrText type='body2'>24</WizrText>
        ),
      },
      {
        title: 'Sentiments',
        dataIndex: 'owner',
        key: 'owner',
        sorter: (a: any, b: any) => a.user_name.localeCompare(b.user_name),
        render: (text: string, folderDetail: any) => (
          <WizrText type='body2'>25</WizrText>
        ),
      },
    ],
    customerInteractions: customColumns || [
      {
        title: <WizrText type='sub2'>Bot Name</WizrText>,
        dataIndex: 'botName',
        key: 'botName',
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>
      },
      {
        title: <WizrText type='sub2'>Conversation</WizrText>,
        dataIndex: 'conversation',
        key: 'conversation',
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>
      },
      {
        title: <WizrText type='sub2'>Category</WizrText>,
        dataIndex: 'category',
        key: 'category',
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>
      },
      {
        title: <WizrText type='sub2'>Date</WizrText>,
        dataIndex: 'date',
        key: 'date',
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>
      },
      {
        title: <WizrText type='sub2'>Time</WizrText>,
        dataIndex: 'time',
        key: 'time',
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>
      }
    ],
    customerInteractionsAgentAssist: customColumns || [
      {
        title: <WizrText type='sub2'>Agent Name</WizrText>,
        dataIndex: 'agent_name',
        key: 'agent_name',
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>
      },
      {
        title: <WizrText type='sub2'>Conversation</WizrText>,
        dataIndex: 'conversation',
        key: 'conversation',
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>
      },
      {
        title: <WizrText type='sub2'>Category</WizrText>,
        dataIndex: 'category',
        key: 'category',
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>
      },
      {
        title: <WizrText type='sub2'>Date</WizrText>,
        dataIndex: 'date',
        key: 'date',
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>
      },
      {
        title: <WizrText type='sub2'>Time</WizrText>,
        dataIndex: 'time',
        key: 'time',
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>
      }
    ],
    alerts: [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        sorter: (a: any, b: any) => a.name.localeCompare(b.name),
        render: (text: string) => (
          <div style={{ maxHeight: '200px', overflow: 'auto', maxWidth: '600px' }}>
            <WizrText type='body2'>{text}</WizrText>
          </div>
        ),
      },
      {
        title: 'Schedule',
        dataIndex: 'crontab_humanized',
        key: 'crontab_humanized',
        sorter: (a: any, b: any) => a.schedule.localeCompare(b.schedule),
        render: (text: string) => (
          <div style={{ maxHeight: '200px', overflow: 'auto', maxWidth: '600px' }}>
            <WizrText type='body2'>{text}</WizrText>
          </div>
        ),
      },
      {
        title: 'Last Run',
        dataIndex: 'last_eval_dttm',
        key: 'last_eval_dttm',
        render: (text: string) => (
          <div style={{ maxHeight: '200px', overflow: 'auto', maxWidth: '600px' }}>
            <WizrText type='body2'>{formatDateToLocal(text)}</WizrText>
          </div>
        ),
      },
      {
        title: 'Enable',
        dataIndex: 'active',
        key: 'active',
        render: (text: any, alertDetail: any) => (
          <WizrFlexLayout flexDirection='row' textAlign='flex-start' justifyContent='flex-start' background='transparent' style={{ maxHeight: '200px', overflow: 'auto' }}>
            <WizrText type='body2' >{text ? 'ACTIVE' : 'INACTIVE'}</WizrText>
            <WizrToggleButton
              isEnabled={text}
              disabled={false}
              onChange={async (checked: boolean) => {
                try {
                  // First, get the alert details
                  const alertDetailsPayload = {
                    alert_id: alertDetail.id,
                    chart_id: alertDetail.chart_id,
                    crontab: alertDetail.crontab || "* * * * *",
                    crontab_humanized: alertDetail.crontab_humanized || "Every minute"
                  };

                  console.log('Fetching alert details for toggle:', alertDetailsPayload);
                  const alertDetailsResponse = await dispatchGetAlertDetails(alertDetailsPayload);

                  if (alertDetailsResponse?.data) {
                    const alertDetails = alertDetailsResponse.data.alert_details;
                    const chartDetails = alertDetailsResponse.data.chart_details;

                    // Create update payload with the toggle status
                    const updatePayload = {
                      alert_id: alertDetail.id,
                      chart_id: alertDetail.chart_id,
                      name: alertDetails?.name || alertDetail.name,
                      recipients: alertDetails?.recipients?.length ?
                        alertDetails.recipients.map((recipient: any) => ({
                          recipient_config_json: {
                            bccTarget: "",
                            ccTarget: "",
                            target: recipient.target
                          },
                          type: "Email"
                        })) : [
                          {
                            recipient_config_json: {
                              bccTarget: "",
                              ccTarget: "",
                              target: alertDetails?.recipients?.[0]?.recipient_config_json?.target || alertDetails?.recipients?.[0]?.target || "default@email.com"
                            },
                            type: "Email"
                          }
                        ],
                      schedule: alertDetails?.crontab || alertDetail.crontab || "* * * * *",
                      columns: chartDetails?.all_columns || [],
                      filters: chartDetails?.adhoc_filters ?
                        [{
                          conditions: chartDetails.adhoc_filters.map((filter: any) => ({
                            type: filter.subject,
                            conditionBy: filter.operator === 'IN' ? '=' : filter.operator,
                            values: Array.isArray(filter.comparator) ? filter.comparator : [filter.comparator]
                          }))
                        }] : [],
                      active: checked, // Use the toggle state
                      email_subject: "",
                      description: ""
                    };

                    console.log('Updating alert with payload:', updatePayload);
                    await dispatchUpdateAlert(updatePayload);

                    // Refresh the alerts list
                    await dispatchGetAlertsForControlRoom({
                      limit: 100,
                      offset: 0
                    });
                  }
                } catch (error) {
                  console.error('Error updating alert enabled status:', error);
                }
              }}
            />
          </WizrFlexLayout>
        ),
      },
      {
        title: 'Last Modified',
        dataIndex: 'changed_on',
        key: 'changed_on',
        render: (text: string) => (
          <div style={{ maxHeight: '200px', overflow: 'auto', maxWidth: '600px' }}>
            <WizrText type='body2'>{formatDateToLocal(text)}</WizrText>
          </div>
        ),
      },
      {
        title: '',
        dataIndex: 'moreAction',
        render: (text: string, alertDetail: any) => (
          <AlertActionPopOver detail={alertDetail} />
        ),
      },
    ],
    reports: [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        sorter: (a: any, b: any) => a.name.localeCompare(b.name),
        render: (text: string) => (
          <div style={{ maxHeight: '200px', overflow: 'auto', maxWidth: '600px' }}>
            <WizrText type='body2'>{text}</WizrText>
          </div>
        ),
      },
      {
        title: 'Schedule',
        dataIndex: 'schedule_details',
        key: 'schedule_details',
        sorter: (a: any, b: any) => {
          const scheduleA = a.schedule_details?.cron || '';
          const scheduleB = b.schedule_details?.cron || '';
          return scheduleA.localeCompare(scheduleB);
        },
        render: (text: any) => (
          <div style={{ maxHeight: '200px', overflow: 'auto', maxWidth: '600px' }}>
            <WizrText type='body2'>{cronToHumanReadable(text?.cron)}</WizrText>
          </div>
        ),
      },
      {
        title: 'Last Run',
        dataIndex: 'last_run',
        key: 'last_run',
        render: (text: string) => (
          <div style={{ maxHeight: '200px', overflow: 'auto', maxWidth: '600px' }}>
            <WizrText type='body2'>{formatDateToLocal(text)}</WizrText>
          </div>
        ),
      },
      {
        title: 'Enable',
        dataIndex: 'enabled',
        key: 'enabled',
        render: (text: any, reportDetail: any) => (
          <WizrFlexLayout flexDirection='row' textAlign='flex-start' justifyContent='flex-start' background='transparent' style={{ maxHeight: '200px', overflow: 'auto', gap: '16px' }}>
            <WizrText type='body2'>{text ? 'ACTIVE' : 'INACTIVE'}</WizrText>
            <WizrToggleButton
              isEnabled={text}
              disabled={false}
              onChange={async (checked: boolean) => {
                try {
                  // Call the edit reports API with the updated enabled status
                  await dispatchAddNewReports({
                    ...reportDetail,
                    enabled: checked
                  });
                  // Refresh the reports list
                  await dispatchGetReportsForControlRoom({
                    limit: 100,
                    offset: 0
                  });
                } catch (error) {
                  console.error('Error updating report enabled status:', error);
                }
              }}
            />
          </WizrFlexLayout>
        ),
      },
      {
        title: 'Last Modified',
        dataIndex: 'last_modified',
        key: 'last_modified',
        render: (text: string) => (
          <div style={{ maxHeight: '200px', overflow: 'auto', maxWidth: '600px' }}>
            <WizrText type='body2'>{formatDateToLocal(text)}</WizrText>
          </div>
        ),
      },
      {
        title: '',
        dataIndex: 'moreAction',
        render: (text: string, reportDetail: any) => (
          <ReportActionPopOver detail={reportDetail} />
        ),
      },
    ],
    trustforteList: [
      {
        title: <WizrText type='sub2'>Email ID</WizrText>,
        dataIndex: 'email_id',
        key: 'email_id',
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>
      },
      {
        title: <WizrText type='sub2'>File Name</WizrText>,
        dataIndex: 'file_name',
        key: 'file_name',
        render: (text: string) => (
          // <FileNameCell>
          <WizrText type='body2'>
            {/* <PdfIcon /> */}
            {text}
          </WizrText>
          // </FileNameCell>
        ),
      },
      {
        title: <WizrText type='sub2'>Received On</WizrText>,
        dataIndex: 'received_on',
        key: 'received_on',
        render: (text: string) => <WizrText type='body2'>{text}</WizrText>
      },
      {
        title: <WizrText type='sub2'>Actions</WizrText>,
        dataIndex: 'actions',
        key: 'actions',
        //render: (text: string) => <WizrButton type='text' text={text}></WizrButton>
      }
    ]
  }



  let columnConfig = tableColumnConfigs[type]

  // Filter out delete column for tickets type if no FAQ records exist
  if (type === 'tickets' && columnConfig) {
    const hasFaqRecords = props?.dataSource?.some((record: any) => record?.type === 'faq')
    if (!hasFaqRecords) {
      // Remove the delete column (last column with empty title, empty dataIndex, and empty key)
      // that only shows content for FAQ type
      columnConfig = columnConfig.filter((col: any, index: number) => {
        // Keep all columns except the delete column (identified by empty title, dataIndex, key, and checking for FAQ in render)
        const isDeleteColumn = col.title === '' &&
          col.dataIndex === '' &&
          col.key === '' &&
          col.render &&
          (col.render.toString().includes('faq') || col.render.toString().includes('DeleteIcon'))
        return !isDeleteColumn
      })
    }
  }

  // Simple resize handler for better responsiveness
  const handleResize = useCallback((columnKey: string) => (
    e: React.SyntheticEvent,
    { size }: { size: { width: number; height: number } }
  ) => {
    // Direct state update for immediate response
    setColumnWidths(prev => ({
      ...prev,
      [columnKey]: size.width,
    }));
  }, []);



  // Process columns to add resizable functionality - memoized for performance
  const resizableColumns = useMemo(() => {
    return columnConfig?.map((col: any, index: number) => {
      const columnKey = col.key || col.dataIndex || `column-${index}`;

      // Set default widths based on column type/content
      const defaultWidth = col.width || (() => {
        if (col.title === 'Name' || col.title === 'Description') return 200;
        if (col.title === 'Tags' || col.title === 'Status') return 120;
        if (col.title === 'Owner' || col.title === 'Created On' || col.title === 'Updated On') return 140;
        if (col.title === 'Actions' || col.title === '') return 90;
        return 150;
      })();

      const currentWidth = columnWidths[columnKey] || defaultWidth;

      const isActionColumn = col.title === '' || col.dataIndex === 'moreAction' || col.dataIndex === 'published' || col.dataIndex === '';
      const isCustomFilterColumn = col.title === 'Status' && col.filterDropdown;
      const isStandardFilterColumn = col.filters && col.filters.length > 0 && !col.filterDropdown;

      // Make most columns resizable, except action columns and standard filter columns
      // Custom filter columns (like Status) can be resizable since they handle their own positioning
      const shouldBeResizable = resizable && !isActionColumn && !isStandardFilterColumn;



      const baseColumn = {
        ...col,
        width: currentWidth,
      };

      if (shouldBeResizable) {
        return {
          ...baseColumn,
          onHeaderCell: (column: any) => ({
            width: currentWidth,
            onResize: handleResize(columnKey),
            style: { cursor: 'default' },
          }),
        };
      } else {
        return {
          ...baseColumn,
        };
      }
    });
  }, [columnConfig, columnWidths, resizable, handleResize]);

  const groupliastingNavigation = (e: any, record: any) => {
    e.stopPropagation();
    const target = e.target;
    const columnIndex = Array.from(target.parentNode.children).indexOf(target);
    const columnName = columnConfig[columnIndex]?.dataIndex;
    if (columnName) {
      routerHistory.navigate(`/featuregroup/${record?.group}/${record?.folder_id}`, {
        state: { files: record },
      })
    }
  }

  const integrationNavigation = (record: any) => {
    localStorage.setItem('redirectCxSetttings', "true")

    routerHistory.navigate('/settings', { state: { action: "settingsedit", data: record } })
    dispatchupdateUserView({
      activeKey: 'integrations',
    })
    dispatchCurrentModule('settings')
  }

  const customerHealthNavigation = (record: any) => {
    dispatchCustomerHealthDetails(record)
  }

  const customerInteractionAutosolveHistory = (record: any) => {
    routerHistory.navigate(`customerInteractions/${record?.folder_id}`)
    dispatchSingleConversationData({ bot_id: record.bot_id, conversation_id: record.conversation_id })
    handleRowClick()
  }


  return (
    <>
      <Table
        columns={resizableColumns}
        {...props}
        style={{ background: '#F2F4F9' }}
        rowSelection={rowSelection}
        components={resizable ? {
          header: {
            cell: ResizableHeaderCell as any,
          },
        } : undefined}
        onRow={(record, rowIndex) => {
          return {
            onClick: event => {
              // Only handle navigation for specific types, not for 'file' type
              if (type === 'grouplisting') {
                groupliastingNavigation(event, record);
              } else if (type === 'integrationsSettings') {
                integrationNavigation(record);
              } else if (type === 'customerHealth') {
                customerHealthNavigation(record);
              } else if (type === 'customerInteractions') {
                customerInteractionAutosolveHistory(record);
              } else if (type === 'customerInteractionsAgentAssist') {
                customerInteractionAgentAssistHistory(record);
              } else if (type === 'past_tickets') {
                // Prevent navigation if clicking on the more action popover or button
                const target = event.target as HTMLElement;
                const currentTarget = event.currentTarget as HTMLElement;

                // Check if click is on popover content or overlay
                if (target.closest('.ant-popover') || target.closest('.ant-popover-content')) {
                  return;
                }

                // Check if click is within the last table cell (moreAction column)
                const clickedCell = target.closest('td');
                if (clickedCell) {
                  const row = clickedCell.closest('tr');
                  if (row) {
                    const cells = row.querySelectorAll('td');
                    const lastCell = cells[cells.length - 1];
                    if (clickedCell === lastCell || lastCell?.contains(target)) {
                      return;
                    }
                  }
                }

                routerHistory.navigate(`past_tickets/${record?.folder_id}`);
              }
              // For 'file' type, do nothing to allow checkbox selection to work
            },
            style: type === 'past_tickets' ? { cursor: 'pointer' } : undefined,
          };
        }}
        rowClassName={() => "rowClassName1"}
        // Performance optimizations for large tables
        pagination={props.pagination ? { pageSize: 50 } : false}
      />
      {resizable && (
        <style dangerouslySetInnerHTML={{
          __html: `
            .react-resizable {
              position: relative;
              background-clip: padding-box;
            }

            .react-resizable-handle {
              position: absolute;
              width: 12px;
              height: 100% !important;
              top: 0 !important;
              right: -6px;
              cursor: col-resize;
              z-index: 10;
              display: flex;
              align-items: center;
              justify-content: center;
              background: transparent;
              opacity: 0; /* Hide the visual handler */
            }

            .react-resizable-handle:hover,
            .react-resizable-handle:active {
              background: transparent;
              opacity: 0; /* Keep hidden even on hover/active */
            }

            /* Prevent sort functionality when clicking on resize handle */
            .react-resizable-handle {
              pointer-events: auto;
            }

            .react-resizable-handle * {
              pointer-events: none;
            }

            /* Only disable sort when resize handle is being dragged */
            .react-resizable-handle:active {
              z-index: 1000;
            }

            /* Prevent sort when resize handle is active */
            .react-resizable-handle:active ~ * {
              pointer-events: none;
            }

            /* Ensure sort icon is clickable while header cell is not */
            .ant-table-column-sorter {
              pointer-events: auto !important;
            }

            /* Disable header cell click for sorting but allow resize */
            .ant-table-thead > tr > th {
              position: relative;
            }

            /* Disable sort on header cells but allow resize handles */
            .ant-table-thead > tr > th {
              pointer-events: none !important;
            }

            /* Re-enable sort only on sort icons */
            .ant-table-thead > tr > th .ant-table-column-sorter {
              pointer-events: auto !important;
              cursor: pointer;
            }

            .ant-table-thead > tr > th .ant-table-column-sorter:hover {
              background-color: #f5f5f5;
            }

            /* Re-enable resize handle with higher specificity */
            .ant-table-thead > tr > th .react-resizable-handle {
              pointer-events: auto !important;
              z-index: 1000 !important;
            }

            /* Ensure resize handle is always clickable */
            .react-resizable-handle {
              pointer-events: auto !important;
              z-index: 1000 !important;
            }

            /* Re-enable pointer events for resize handle */
            .ant-table-thead > tr > th .react-resizable-handle {
              pointer-events: auto !important;
            }

            .ant-table-thead > tr > th.react-resizable {
              user-select: none;
            }

          
            .ant-table-thead > tr > th.ant-table-selection-column {
              pointer-events: auto !important;
            }

            .ant-table-thead > tr > th.ant-table-selection-column .ant-checkbox-wrapper {
              pointer-events: auto !important;
              cursor: pointer;
            }

            /* Custom column border styling */
            .ant-table-thead > tr > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before,
            .ant-table-thead > tr > td:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
              position: absolute;
              top: 0;
              inset-inline-end: 0;
              width: 1.2px;
              height: 100%;
              background-color: #ffffff;
              content: "";
              transition: background-color 0.2s;
            }

            /* Ensure hover styles work for sorted columns */
            .ant-table-thead > tr > th.ant-table-column-has-sorters:hover,
            .ant-table-thead > tr > th.ant-table-column-sort:hover {
              background-color: #fafafa !important;
            }

            /* Override any conflicting styles for sorted columns */
            .ant-table-thead > tr > th.ant-table-column-has-sorters.ant-table-column-sort:hover {
              background-color: #fafafa !important;
            }

            /* Ensure consistent hover behavior for all header cells */
            .ant-table-thead > tr > th:hover {
              background-color: #fafafa !important;
            }

            /* Fix row hover styles for sorted columns */
            .ant-table-tbody > tr:hover > td {
              background-color: #fafafa !important;
            }

            /* Ensure sorted column cells also get hover styles */
            .ant-table-tbody > tr:hover > td.ant-table-column-sort {
              background-color: #fafafa !important;
            }

            /* Override any conflicting styles for sorted column cells */
            .ant-table-tbody > tr:hover > td.ant-table-cell.ant-table-column-sort {
              background-color: #fafafa !important;
            }

            /* Handle any nested sort indicators */
            .ant-table-tbody > tr:hover > td .ant-table-column-sort {
              background-color: #fafafa !important;
            }

                                  /* Remove the header-only indicator */
            .react-resizable-handle:active::after {
              display: none;
            }

            /* Fix text wrapping for Name column in Knowledge Base */
            .ant-table-tbody > tr > td:first-child .ant-btn {
              white-space: normal !important;
              word-wrap: break-word !important;
              text-align: left !important;
            }
          `}} />
      )}
    </>
  )
}

export default WizrTable